// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-09T16:35:23.338Z
// Property: The Legend (ID: 5738013569056768)
// Collections: 23 amenities, 5 floorplans (live), 22 photos, 83 POIs, 4 reviews, 2 virtual tours, 7 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5738013569056768",
  "property_external_id": "4981188",
  "property_zillow_url": "https://www.zillow.com/homedetails/8797-Marbach-Rd-San-Antonio-TX-78227/299595637_zpid/",
  "property_apartments_url": "https://www.apartments.com/the-legend-san-antonio-tx/vnr3dbe",
  "property_google_business_url": "https://www.google.com/maps/place/The+Legend/data=!4m2!3m1!1s0x0:0xa99576455f6f1cfb?sa=X&ved=2ahUKEwjA_cO_0bySAxURETQIHUjgJpIQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "8443916049",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-legend",
  "property_name": "The Legend",
  "property_website_url": "https://www.thelegendtexas.com",
  "property_domain": "https://www.thelegendtexas.com/",
  "property_address": "8797 Marbach Rd",
  "property_full_address": "8797 Marbach Rd, San Antonio, TX 78227",
  "property_address_1": "8797 Marbach Rd",
  "property_address_2": null,
  "property_address_city": "San Antonio",
  "property_address_state": "TX",
  "property_address_zip_full": "78227-2356",
  "property_address_zip": "78227",
  "property_address_country": "US",
  "property_address_county": "Bexar County",
  "property_neighborhood_address": "Far West Side",
  "property_address_latitude": "29.4189055",
  "property_address_longitude": "-98.6595584",
  "property_email": "legend@alapts.com",
  "property_phone": "(210) 673-5502",
  "property_call_tracking_phone": "361-306-1322",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Live connected on San Antonio’s Far West Side.</strong> The Legend pairs one, two, and three bedroom apartments with comfortable finishes, inviting community spaces, and quick access to major routes—<a href=\"/schedule-a-tour\">schedule a tour</a> to see it all in person.</p>",
  "property_long_description": "<p><strong>Live connected on San Antonio’s Far West Side.</strong> At The Legend, you can settle into a one, two, or three bedroom apartment with everyday comfort built in—walk-in closets, patios or balconies, high-speed internet access, and select homes with washer and dryer connections, bay windows, kitchen islands, granite countertops, stainless steel appliances, and designer finishes.</p><p>Beyond your front door, the community gives you more room to unwind and get things done, from a zen-style pool with sunning deck and fountain to a clubhouse, gameroom, resident tech center, fitness center, sports court, grilling areas, package lockers, and a bark park. Explore the <a href=\"/amenities\">amenities</a> that make daily routines feel easier.</p><p>Your Westover Hills location keeps essentials close, with H-E-B Plus!, Marbach Square, Alamo Drafthouse Westlakes, Rainbow Hills Park, Heritage Duck Pond Park, and SeaWorld San Antonio within easy reach. With quick connections to Loop 410, Highway 151, and US-90, you’re positioned for a convenient San Antonio lifestyle.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019d02f3-564c-703f-b796-e1e38f3d6a30.webp",
  "property_featured_image_media": {
    "alt_text": "Kitchen island with orange bar stools and granite countertop.",
    "public_id": "019d02f3-564c-703f-b796-e1e38f3d6a30",
    "storage_key": "property/5738013569056768/019d02f3-564c-703f-b796-e1e38f3d6a30.webp",
    "width": 1240,
    "height": 827
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "480",
  "property_year_built": "2007",
  "property_year_renovated": "2022",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95",
  "property_admin_fee": "150",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Application Fee $75\nAdministrative Fee $150\nNon-Refundable Pet Fee $300 / pet\nMonthly Pet Rent $20 / pet\nApplication Approval Fee Starting At $300",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "20",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $20 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $20 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8879180.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://thelegendapts.loftliving.com/login",
  "property_apply_now_url": "https://www.thelegendtexas.com/apply-now",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019d02f3-42a0-72ee-8b68-17c2e0428c73.webp",
  "property_primary_logo_media": {
    "alt_text": "The Legend Premier Apartments logo",
    "public_id": "019d02f3-42a0-72ee-8b68-17c2e0428c73",
    "storage_key": "property/5738013569056768/019d02f3-42a0-72ee-8b68-17c2e0428c73.webp",
    "width": 1920,
    "height": 371
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019d02f3-110e-73b9-af7b-058d3631677b.webp",
  "property_secondary_logo_media": {
    "alt_text": "The Legend Premier Apartments logo",
    "public_id": "019d02f3-110e-73b9-af7b-058d3631677b",
    "storage_key": "property/5738013569056768/019d02f3-110e-73b9-af7b-058d3631677b.webp",
    "width": 1920,
    "height": 371
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019e73e6-4404-7358-80cc-e6eb71d5f497.webp",
  "property_icon_media": {
    "alt_text": "Logo with a gold circle and blue L inside",
    "public_id": "019e73e6-4404-7358-80cc-e6eb71d5f497",
    "storage_key": "property/5738013569056768/019e73e6-4404-7358-80cc-e6eb71d5f497.webp",
    "width": 856,
    "height": 855
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019e73e6-4404-7358-80cc-e6eb71d5f497.webp",
  "property_fav_icon_media": {
    "alt_text": "Logo with a gold circle and blue L inside",
    "public_id": "019e73e6-4404-7358-80cc-e6eb71d5f497",
    "storage_key": "property/5738013569056768/019e73e6-4404-7358-80cc-e6eb71d5f497.webp",
    "width": 856,
    "height": 855
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019d02f3-4a0a-71b5-bb08-861709f0228d.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Legend Premier Apartments logo.",
    "public_id": "019d02f3-4a0a-71b5-bb08-861709f0228d",
    "storage_key": "property/5738013569056768/019d02f3-4a0a-71b5-bb08-861709f0228d.webp",
    "width": 270,
    "height": 52
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019e73e6-43e5-747c-a738-fbad751970ff.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Legend Premier Apartments logo",
    "public_id": "019e73e6-43e5-747c-a738-fbad751970ff",
    "storage_key": "property/5738013569056768/019e73e6-43e5-747c-a738-fbad751970ff.webp",
    "width": 2489,
    "height": 452
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#244c5a",
  "property_secondary_color": "#79a5b8",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#a68151",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "499 - 1150",
  "property_sqft_min": "499",
  "property_sqft_max": "1150",
  "property_price_range": "879.66 - 1554.66",
  "property_price_min": "879.66",
  "property_price_max": "1554.66",
  "property_available_units": 24,
  "property_facebook_url": "https://www.facebook.com/TheLegendApartments",
  "property_instagram_url": "https://www.instagram.com/thelegendtexas",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJnXYOLatcXIYR-xxvX0V2lak",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/the-legend-san-antonio",
  "property_tiktok_url": "https://www.tiktok.com/@thelegendapts",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Details that make every day easier.</strong> At The Legend, a zen pool with a sunning deck and fountain sets the tone, while a modern fitness center, sports court, grilling areas, tech center, Parcel Pending lockers, and bark park keep essentials close.</p><p>Inside, one, two, and three bedroom apartments offer practical touches like walk-in closets, built-in bookshelves, patios or balconies, and select modern finishes such as kitchen islands, stainless steel appliances, and smart entry locks.</p>",
  "property_home_floorplans_blurb": "<p><strong>Find your fit at The Legend.</strong> Explore one, two, and three bedroom apartments in San Antonio with open living and dining areas, walk-in closets, pantries, and patios or balconies. Select layouts add everyday standouts like washer and dryer connections, modern kitchen islands, built-in bookshelves, bay windows, designer cabinetry, and sleek kitchen finishes.</p>",
  "property_home_gallery_blurb": "<p><strong>Get a glimpse of The Legend.</strong> Preview bright interiors with balcony or patio views, clean cabinetry, select granite-style finishes, and bedrooms with space to settle in. Then picture the community beyond your front door, from the lounge-lined pool and fitness center to the clubhouse, tech center, sports court, and bark park. Browse the full gallery to see more of life at 8797 Marbach Rd.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Westover Hills access, Marbach Road convenience.</strong> The Legend keeps daily stops, casual dining, and errands close, with Loop 410, Highway 151, and US-90 nearby for easy San Antonio connections.</p><p>Grab seafood at El Bucanero, Tex-Mex at Los Cabos, shop toward Alamo Ranch, or unwind at Slick Park and Medina Base Road Park. Explore the neighborhood map to see what’s close.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents keep coming back to the everyday ease.</strong> Reviews for The Legend highlight a quiet setting, fair pricing, spacious layouts, clean community spaces, and a team often described as friendly and helpful. Look for praise around responsive maintenance, well-kept grounds, smooth move-ins, upgraded finishes, the pool, and convenient access to nearby essentials.</p>",
  "property_neighborhood_blurb": "<p><strong>Your Westover Hills map opens up fast.</strong> From The Legend, Marbach Road puts everyday stops, casual dining, and quick errands close at hand, with Loop 410, Highway 151, and US-90 nearby when your plans stretch across San Antonio.</p><p>Stay local for seafood at El Bucanero or Tex-Mex at Los Cabos, head toward Alamo Ranch for larger shopping trips, or spend open time at Slick Park and Medina Base Road Park. The Westover Hills corridor also connects you to Northwest Vista College, CHRISTUS Santa Rosa Hospital, and major west-side destinations without losing the easygoing rhythm of home. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how the location fits your day.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Comfort is in the details.</strong> At The Legend, your amenities are built for the way the day actually moves—from a zen pool with a sunning deck and fountain to a modern fitness center, sports court, grilling areas, resident tech center, and Parcel Pending package lockers. Bring your pet along for time at the bark park, get things done with 24/7 online resident services, or unwind in community spaces with WiFi access coming soon.</p><p>Inside your San Antonio apartment, choose from one, two, and three bedroom <a href=\"/floor-plans\">floor plans</a> with practical touches like walk-in closets, built-in bookshelves, patios or balconies, and available washer and dryer connections. Select homes and upcoming finishes may add modern kitchen islands, stainless steel appliances, granite-style counters, decorative tile backsplashes, USB outlets, and smart entry locks. Preview it all in the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_applynow_blurb": "<p><strong>Start your next chapter at The Legend.</strong> Choose a one, two, or three bedroom apartment with everyday comforts like walk-in closets, patios or balconies, and high-speed internet access. With relaxing community spaces and convenient Far West Side connections, applying online is a simple first step toward home.</p>",
  "property_contactus_blurb": "<p><strong>Have questions? We’re here to help.</strong> Contact The Legend leasing team to learn more about our one, two, and three bedroom apartments, everyday comforts, community spaces, and convenient Westover Hills location. Reach out today for details or directions to our San Antonio community.</p>",
  "property_faqs_blurb": "<p><strong>Questions about life at The Legend?</strong> Find quick answers about our one, two, and three bedroom apartments, community features, leasing details, and everyday living on San Antonio’s Far West Side. If you need more information, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Choose the space that fits your next chapter.</strong> The Legend offers one, two, and three bedroom apartment floor plans in San Antonio, ranging from efficient one-bath designs to roomier two-bath layouts with added flexibility. Open living and dining areas make it easy to arrange your furniture, while walk-in closets, pantries, patios or balconies, and select homes with washer and dryer connections help your daily routine feel more organized.</p><p>As you browse availability, look for layout details that elevate the everyday: modern kitchen islands, built-in bookshelves, bay windows, designer cabinetry, and sleek kitchen finishes in select homes. Compare each plan’s pricing and availability, explore more <a href=\"/amenities\">apartment features</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see the layout that feels right in person.</p>",
  "property_gallery_blurb": "<p><strong>See The Legend from every angle.</strong> Browse photos that move from bright apartment interiors to inviting outdoor spaces, giving you a clearer feel for daily life in this Westover Hills community. Picture a living room opening to a balcony or patio, a kitchen framed by clean cabinetry and select granite-style finishes, and a bedroom with room to settle in.</p><p>The gallery also captures the spaces that make time at home more enjoyable: a pool lined with lounge seating, a fitness center ready for your routine, a resident tech center, sports court, clubhouse, and bark park. When a photo catches your eye, compare <a href=\"/floor-plans\">available layouts</a>, explore more <a href=\"/amenities\">community features</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see The Legend in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore life on San Antonio’s Far West Side.</strong> Use the interactive map to view available one, two, and three bedroom apartments, then see how The Legend connects you to Westover Hills essentials, nearby parks, entertainment, and quick routes via Loop 410, Highway 151, and US-90.</p>",
  "property_pets_blurb": "<p><strong>Room for whiskers, wagging tails, and everyday ease.</strong> At The Legend, cats and dogs are welcome with up to two pets per apartment and no weight limit, giving your companions space to settle in comfortably. Keep daily routines simple with outdoor strolls around the community, sunny balcony or patio time, and play sessions at the bark park designed for furry friends.</p><p>When it is time to head back inside, one, two, and three bedroom homes offer practical comfort for shared living with your pet. Explore more <a href=\"/amenities\">pet-friendly amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see The Legend in person.</p>",
  "property_referafriend_blurb": "<p><strong>Share life at The Legend.</strong> If you love the everyday comfort of your apartment, the spaces to unwind, and the easy Far West Side connections, invite a friend to experience it too. Send a referral and help them find their next one, two, or three bedroom home in San Antonio.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at The Legend.</strong><br>Stay connected to everyday comfort from your resident portal. Log in to pay rent, submit maintenance requests, and manage your account—so home routines on San Antonio’s Far West Side stay simple and convenient.</p>",
  "property_reviews_blurb": "<p><strong>Hear what residents are saying.</strong> Reviews for The Legend often point to the details that make daily life feel easier: a quiet setting, fair pricing, spacious apartment options, clean shared spaces, and a team described as “friendly and helpful.”</p><p>You’ll see residents call out responsive maintenance, visible care around the grounds, and thoughtful move-in support that helps the experience start on the right note. Others highlight the upgraded finishes, pool, and everyday convenience of having essentials close by. As you browse the ratings, look for the recurring themes—attentive service, practical comfort, and a community that residents are happy to recommend.</p>",
  "property_created_at": "1752256661945",
  "property_scheduletour_blurb": "<p><strong>See The Legend up close.</strong> Tour one, two, and three bedroom apartments with everyday comforts like walk-in closets, patios or balconies, and available designer finishes—then explore the pool, clubhouse, fitness center, and bark park. Schedule your tour today and picture life on San Antonio’s Far West Side.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong> The Legend leasing team will be in touch soon to help with your next steps. In the meantime, picture everyday comfort on San Antonio’s Far West Side, with spacious apartment layouts, relaxing community spaces, and convenient connections close to home.</p>",
  "property_virtualtours_blurb": "<p><strong>Step inside before you arrive.</strong> The Legend’s virtual tours give you a closer look at the spaces that shape daily life here, starting with the community tour and a walkthrough of a two-bedroom, one-bath apartment. Move at your own pace, revisit details, and get a feel for the layout from anywhere.</p><p>In the apartment tour, follow the open living and dining area into a kitchen with clean cabinetry, modern appliances, and polished countertop finishes, then take in practical touches like natural light, comfortable bedroom space, and everyday storage. After you explore, compare <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see The Legend in San Antonio in person.</p>",
  "property_copyright": "2025 All Rights Reserved. The Legend",
  "property_seo_title_home": "The Legend | Apartments in San Antonio, TX",
  "property_seo_description_home": "Discover modern living at The Legend in San Antonio, TX! Choose from spacious one, two, and three-bedroom floor plans featuring top-notch amenities like a fitness center, pool, dog park, and convenient LUXER package lockers. Enjoy smart home features and online resident services for effortless living. Ready to elevate your lifestyle? Find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in San Antonio, TX",
  "property_seo_description_floorplans": "Discover your ideal living space at The Legend in San Antonio, TX! Explore our thoughtfully designed one, two, and three-bedroom floor plans that cater to your unique lifestyle. Browse our available apartment homes today and find the perfect floor plan to call your own!",
  "property_seo_title_amenities": "Amenities | San Antonio, TX Apartments for Rent",
  "property_seo_description_amenities": "Discover a lifestyle of comfort and convenience at The Legend in San Antonio, TX! Explore our thoughtfully designed one, two, and three-bedroom floor plans alongside exceptional amenities like a dog park, fitness center, and luxurious pool. Enjoy modern features such as built-in bookcases, smart locks, and USB outlets. With online resident services and top-tier appliances, your new home awaits. Don’t miss out—explore our incredible community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in San Antonio, TX",
  "property_seo_description_gallery": "Discover your dream home at The Legend in San Antonio, TX! Explore our stunning photo gallery showcasing spacious one, two, and three-bedroom floor plans, each featuring modern amenities including a sparkling pool, fitness center, and dog park. Picture yourself enjoying conveniences like smart locks, USB outlets, and access to our cyber café. Experience the lifestyle you deserve—view all our homes today and start envisioning your future!",
  "property_seo_title_virtualtours": "Virtual Tours | The Legend Apartments",
  "property_seo_description_virtualtours": "\"Explore The Legend in San Antonio, TX! Discover a variety of floor plans, including one, two, and three-bedroom apartments, tailored to fit your lifestyle. Take a virtual tour of our inviting community and see why your next home awaits. Don’t miss out—start your journey today!\"",
  "property_seo_title_interactivemap": "Interactive Map | The Legend Apartments",
  "property_seo_description_interactivemap": "Discover your ideal living space at The Legend in San Antonio, TX! With diverse floor plans including one, two, and three-bedroom options, our community offers luxurious amenities like a state-of-the-art fitness center, a refreshing pool, and a dog park. Enjoy modern conveniences such as LUXER package lockers, smart locks, and full-size washer/dryer in unit. Explore our interactive community map to view available apartments, pricing, and find your perfect home today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in San Antonio, TX",
  "property_seo_description_neighborhood": "Discover your ideal living space at The Legend in San Antonio, TX! Explore our diverse floor plans, featuring one, two, and three-bedroom apartments. Uncover the vibrant neighborhood by checking out local favorites and nearby points of interest. See what's around our community and experience the best of San Antonio living today!",
  "property_seo_title_contact": "Contact Us | The Legend",
  "property_seo_description_contact": "Discover your perfect home at The Legend in San Antonio, TX! Explore our versatile floor plans, including one, two, and three-bedroom apartments designed for modern living. Have questions? Contact our leasing team today to learn more about our community and how we can help you find your ideal space!",
  "property_seo_title_faqs": "FAQs | Apartments in San Antonio, TX",
  "property_seo_description_faqs": "Discover the perfect home at The Legend in San Antonio, TX! With a range of thoughtfully designed floor plans—including one, two, and three-bedroom options—you're sure to find the ideal space for your lifestyle. Enjoy exceptional amenities like a state-of-the-art fitness center, a relaxing pool, a dog park, and convenient online resident services. Have questions? Browse our FAQs page to learn more about our community and discover why The Legend is the ideal place to call home!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in San Antonio, TX",
  "property_seo_description_reviews": "Discover why residents love calling The Legend home in San Antonio, TX! Explore spacious one, two, and three-bedroom floor plans featuring top-notch amenities like our dog park, fitness center, and cyber café. Enjoy the convenience of smart locks, USB outlets, and full-size in-unit washers & dryers. With access gates, a pool, and a grilling area, life here offers both comfort and convenience. Don’t just take our word for it—see what our residents have to say about living at our vibrant community!",
  "property_seo_title_applynow": "Apply Now | Apartments in San Antonio, TX",
  "property_seo_description_applynow": "Discover your perfect home at The Legend in San Antonio, TX! Choose from a variety of spacious floor plans, including one, two, and three-bedroom options. Enjoy luxurious amenities like a state-of-the-art fitness center, dog park, and a refreshing pool. With smart locks, USB outlets, and built-in bookcases, comfort and convenience are just a click away. Don’t wait—apply now and lease your new apartment online today!",
  "property_seo_title_residentaccess": "Resident Access | The Legend",
  "property_seo_description_residentaccess": "\"Welcome to The Legend in San Antonio, TX! Access your resident portal now to conveniently pay rent, schedule maintenance, and manage your apartment needs, all in one place!\"",
  "property_seo_title_referafriend": "Refer A Friend | The Legend",
  "property_seo_description_referafriend": "\"Share the love at The Legend in San Antonio, TX! Refer a friend to our vibrant apartment community and enjoy great neighbors and exclusive rewards. Great friends make great neighbors - submit your referral today!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | The Legend",
  "property_seo_description_scheduletour": "\"Discover your new home at The Legend in San Antonio, TX! Experience unparalleled amenities and a vibrant community lifestyle. Schedule a tour today and see why The Legend is the perfect place to call home!\"",
  "property_seo_title_privacy": "Privacy Policy | The Legend",
  "property_seo_description_privacy": "\"Discover your sanctuary at The Legend in San Antonio, TX. Your privacy matters to us! Explore our comprehensive privacy policy to learn how we protect your information. View our privacy policy today!\"",
  "property_seo_title_accessibility": "Website Accessibility | The Legend",
  "property_seo_description_accessibility": "Discover The Legend in San Antonio, TX, where we prioritize digital inclusion! Our comprehensive Accessibility Statement ensures all residents and visitors can navigate our community effortlessly. Join us in creating a welcoming space for everyone. Explore our commitment to accessibility today!",
  "property_seo_title_sitemap": "Sitemap | The Legend",
  "property_seo_description_sitemap": "Discover every corner of The Legend, your premier apartment community in San Antonio, TX. Explore our sitemap to find your perfect home and learn about our amenities, floor plans, and special offers. View our website sitemap now!",
  "property_seo_title_thankyou": "Thank You | The Legend",
  "property_seo_description_thankyou": "Thank you for reaching out to The Legend in San Antonio, TX! We appreciate your interest. A member of our team will be in touch soon to assist you in finding your perfect apartment home. Stay tuned for exciting updates and offers tailored just for you!",
  "property_seo_title_pets": "Pet Policy | Apartments in Summerville, SC\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234320679",
  "amenities": [
    {
      "id": "custom_cce51c23-a23c-4d26-9262-f32771b38b50",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances**",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9a5b3666-e437-4253-975f-645d83e76f33",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Sleek Granite Kitchen Countertops**",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bbfb5fb6-e16e-4995-95ba-746bd1485b98",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "custom",
      "external_id": "P000000652",
      "title": "Kitchen Islands",
      "amount": "0.0000",
      "description": "Modern Kitchen Islands*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fea00d0e-6cd7-4493-8ee0-c71b58af9291",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "custom",
      "external_id": "P000000703",
      "title": "W&D Connections",
      "amount": "0.0000",
      "description": "In-Home Full-Size Washer & Dryer Connections*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_adc22400-7841-4c3d-a71f-42871bbf0470",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "custom",
      "external_id": "P000000604",
      "title": "Built-In Bookcase",
      "amount": "0.0000",
      "description": "Built-in Bookshelves",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fc24b05d-92e9-4024-a6eb-e8eb14e6c7b3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "custom",
      "external_id": "P000000609",
      "title": "Cabinets",
      "amount": "0.0000",
      "description": "Designer Cabinetry",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_79f731f5-1538-4a17-abbf-27955a3afe6d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "custom",
      "external_id": "P000000695",
      "title": "Tile Backsplash",
      "amount": "0.0000",
      "description": "Decorative Tile Backsplash**",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1ed15d37-2cb6-48f1-a886-c877d6d9ce90",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "custom",
      "external_id": "P000000698",
      "title": "USB Outlet",
      "amount": "0.0000",
      "description": "USB Outlets**",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_84a6c422-ecfd-4476-a426-0e2c93a35421",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "custom",
      "external_id": "P000000710",
      "title": "Windows",
      "amount": "0.0000",
      "description": "Bay Windows*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_157c7655-8d94-4fc0-a0c2-5c902e7ae0ef",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "custom",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*In Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_93548a26-2d58-46a2-8beb-15fe927b7866",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "custom",
      "external_id": "P000000593",
      "title": "*Coming Soon",
      "amount": "0.0000",
      "description": "**Coming Soon",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0cf123a2-a8d8-4b6d-a255-df6d7a305e94",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Zen Pool w/Sunning Deck & Fountain",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f5567edf-7345-48b2-b75f-6308ea0e7487",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "custom",
      "external_id": "P000000685",
      "title": "Sports Court",
      "amount": "0.0000",
      "description": "Sports Court",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1146c3c7-4223-4954-991d-bc8e9fd5029f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Bark Park for your Furry Friends",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_90968974-4216-4235-a3fa-7fa2f2558960",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "custom",
      "external_id": "P000001409",
      "title": "WiFi at Pool & Clubhouse",
      "amount": "0.0000",
      "description": "WiFi Access at Pool & Clubhouse**",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c409ada4-01d6-4a0c-9203-beb6a576f7d7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "custom",
      "external_id": "P000002384",
      "title": "Cyber Cafe",
      "amount": "0.0000",
      "description": "Resident Tech Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_093a3e68-3ec4-404e-8ad8-74a9b7a1665c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "custom",
      "external_id": "P000000644",
      "title": "Grill Area",
      "amount": "0.0000",
      "description": "Community Grilling Areas",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f62d67f4-93a6-46e1-8cd4-daff33f26c86",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Modern Fitness Center**",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7ef98cdf-bfeb-4ccf-a180-980ec7ca019d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "custom",
      "external_id": "P000000594",
      "title": "Access Gates",
      "amount": "0.0000",
      "description": "Controlled Access Gates",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8376b004-5c5c-4531-9838-f047b2ede4fe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "custom",
      "external_id": "P000000687",
      "title": "Storage Spaces",
      "amount": "0.0000",
      "description": "Onsite Storage Available",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2e757e31-1ddc-4379-bbcf-82f9a6fc74ef",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "custom",
      "external_id": "P000000145",
      "title": "LUXER Package Locker",
      "amount": "0.0000",
      "description": "Parcel Pending Package Lockers",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c7419a31-09c6-4b90-a66a-324f670b3ff1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c8e13f60-dd37-4cf9-a19d-12567cdce5c6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_cacb0aa6-b346-422a-83a1-63a175ae509a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019e8a00-e103-7645-b511-f44dc654f115.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and cabanas, overlooking apartment buildings and landscaping.",
        "public_id": "019e8a00-e103-7645-b511-f44dc654f115",
        "storage_key": "property/5738013569056768/019e8a00-e103-7645-b511-f44dc654f115.webp",
        "width": 3072,
        "height": 2301
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling resort-style swimming pool, surrounded by comfortable lounge chairs and shaded cabanas. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and cabanas, overlooking apartment buildings and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_16ebdab5-4cba-4fd1-a7f3-b48665debb72",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019e8a00-cd6c-7404-95a3-9837f1079228.webp",
      "image_media": {
        "alt_text": "Modern package lockers with geometric pattern and property name.",
        "public_id": "019e8a00-cd6c-7404-95a3-9837f1079228",
        "storage_key": "property/5738013569056768/019e8a00-cd6c-7404-95a3-9837f1079228.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Secure and stylish package lockers available for residents at The Legend Premier Apartments, featuring a contemporary geometric design.",
      "link": "",
      "alt_text": "Modern package lockers with geometric pattern and property name.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_016fa4a2-484b-4abf-9299-4f71d7fa23a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019e8a00-cd5e-70ec-97ec-20c1c6f81a6d.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, large window with blinds, and nightstand with a lamp.",
        "public_id": "019e8a00-cd5e-70ec-97ec-20c1c6f81a6d",
        "storage_key": "property/5738013569056768/019e8a00-cd5e-70ec-97ec-20c1c6f81a6d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "A beautifully appointed bedroom featuring a plush king-size bed, complemented by decorative pillows and a cozy throw. The room is illuminated by natural light from a large window, and a stylish nightstand with a lamp adds to the ambiance.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, large window with blinds, and nightstand with a lamp.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9fb4e036-e5c4-4774-8c0d-23324405cff1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019e8a00-caef-70e8-bfce-dd14f1dd9620.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, recumbent bike, weight rack, and exercise balls.",
        "public_id": "019e8a00-caef-70e8-bfce-dd14f1dd9620",
        "storage_key": "property/5738013569056768/019e8a00-caef-70e8-bfce-dd14f1dd9620.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio machines, weight training equipment, and free weights.",
      "link": "",
      "alt_text": "Fitness center with treadmills, recumbent bike, weight rack, and exercise balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8f54562f-6e67-42a5-91da-f3582a08a7ea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019e8a00-cc39-772c-99bd-6badca999a59.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white vanity, granite countertop, and a bathtub with shower.",
        "public_id": "019e8a00-cc39-772c-99bd-6badca999a59",
        "storage_key": "property/5738013569056768/019e8a00-cc39-772c-99bd-6badca999a59.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Enjoy a spa-like experience in your modern bathroom, featuring a spacious vanity with ample storage and a pristine bathtub and shower.",
      "link": "",
      "alt_text": "Modern bathroom with a white vanity, granite countertop, and a bathtub with shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0e06e380-5758-4d73-9340-e23c30dae25b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019e8a00-cd3b-77e8-9761-8cfde1ed5009.webp",
      "image_media": {
        "alt_text": "Stylish home office with a desk, chair, and bookshelf.",
        "public_id": "019e8a00-cd3b-77e8-9761-8cfde1ed5009",
        "storage_key": "property/5738013569056768/019e8a00-cd3b-77e8-9761-8cfde1ed5009.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Create your ideal workspace in this beautifully appointed home office, featuring a modern desk, comfortable seating, and ample storage.",
      "link": "",
      "alt_text": "Stylish home office with a desk, chair, and bookshelf.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9b0cf4ae-59c0-42e9-a0ff-e753c8c8d3ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019e8a00-cfdd-73ac-be71-9f706bf01871.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with stainless steel appliances and a round dining table.",
        "public_id": "019e8a00-cfdd-73ac-be71-9f706bf01871",
        "storage_key": "property/5738013569056768/019e8a00-cfdd-73ac-be71-9f706bf01871.webp",
        "width": 3072,
        "height": 2085
      },
      "title": "Apartment",
      "description": "Modern kitchen and dining area featuring stainless steel appliances, granite countertops, and a stylish round dining table with upholstered chairs.",
      "link": "",
      "alt_text": "Kitchen and dining area with stainless steel appliances and a round dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_657be03b-796f-44ef-9fa1-80d660af7078",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019e8a00-cce7-7178-9a9b-b711894bfa30.webp",
      "image_media": {
        "alt_text": "Vibrant blue basketball court with white markings at a multifamily property.",
        "public_id": "019e8a00-cce7-7178-9a9b-b711894bfa30",
        "storage_key": "property/5738013569056768/019e8a00-cce7-7178-9a9b-b711894bfa30.webp",
        "width": 3072,
        "height": 2301
      },
      "title": "Community",
      "description": "Enjoy an active lifestyle with our full-size basketball court, perfect for a friendly game or a workout.",
      "link": "",
      "alt_text": "Vibrant blue basketball court with white markings at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bd53ec57-e9fd-476f-b3d5-34313ac91c74",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019e8a00-be06-765e-a099-e1f8cc0277f1.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, armchair, and large windows.",
        "public_id": "019e8a00-be06-765e-a099-e1f8cc0277f1",
        "storage_key": "property/5738013569056768/019e8a00-be06-765e-a099-e1f8cc0277f1.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Comfortable living room featuring a plush sofa, stylish coffee table, and an armchair, all complemented by natural light from large windows.",
      "link": "",
      "alt_text": "Living room with a sofa, coffee table, armchair, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_24521ee8-f941-4d06-ac67-3ca35c855ce9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019e8a00-bf4a-71fa-91f3-6f9036dfdfeb.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with a rock waterfall and lounge chairs.",
        "public_id": "019e8a00-bf4a-71fa-91f3-6f9036dfdfeb",
        "storage_key": "property/5738013569056768/019e8a00-bf4a-71fa-91f3-6f9036dfdfeb.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by the resort-style swimming pool, complete with a soothing rock waterfall and comfortable lounge seating.",
      "link": "",
      "alt_text": "Resort-style swimming pool with a rock waterfall and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d1b1d29c-78fb-4086-91b5-9f9e9250b3ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019e8a00-9ea7-75e0-bd90-a07ce05c3dd4.webp",
      "image_media": {
        "alt_text": "Lounge area with black leather couches, stone fireplace, and patterned rug.",
        "public_id": "019e8a00-9ea7-75e0-bd90-a07ce05c3dd4",
        "storage_key": "property/5738013569056768/019e8a00-9ea7-75e0-bd90-a07ce05c3dd4.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax in the stylish lounge area featuring comfortable seating, a cozy stone fireplace, and a decorative rug, perfect for unwinding.",
      "link": "",
      "alt_text": "Lounge area with black leather couches, stone fireplace, and patterned rug.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cc963e74-89a2-4236-aec1-8ee6a8a079a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019e8a00-99c8-7340-ae33-9cdd9b8da2cd.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, surrounded by landscaping and apartment buildings.",
        "public_id": "019e8a00-99c8-7340-ae33-9cdd9b8da2cd",
        "storage_key": "property/5738013569056768/019e8a00-99c8-7340-ae33-9cdd9b8da2cd.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip or relax by our sparkling swimming pool, complete with ample loungers and shaded areas for ultimate comfort.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, surrounded by landscaping and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_41ad3174-4f83-48ec-8b8c-fb8552613762",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019e8a00-9b23-773e-aa40-56313434e68e.webp",
      "image_media": {
        "alt_text": "Living room with a couch, coffee table, TV, and decorative items.",
        "public_id": "019e8a00-9b23-773e-aa40-56313434e68e",
        "storage_key": "property/5738013569056768/019e8a00-9b23-773e-aa40-56313434e68e.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Stylish and comfortable living room featuring a plush sofa, a modern entertainment center with a large TV, and elegant decor.",
      "link": "",
      "alt_text": "Living room with a couch, coffee table, TV, and decorative items.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a3981d6e-e2b7-4987-8335-1b70dcb24475",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019e8a00-9af5-721a-944e-ab73e7122ec3.webp",
      "image_media": {
        "alt_text": "Balcony entrance with double doors and a window, surrounded by stone and siding.",
        "public_id": "019e8a00-9af5-721a-944e-ab73e7122ec3",
        "storage_key": "property/5738013569056768/019e8a00-9af5-721a-944e-ab73e7122ec3.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy private outdoor space on your balcony, featuring double doors and a window for natural light.",
      "link": "",
      "alt_text": "Balcony entrance with double doors and a window, surrounded by stone and siding.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fa4afcd2-5349-42d9-aeeb-bd2ccefec77e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019e8a00-9c8d-7367-98a8-0a08028659f9.webp",
      "image_media": {
        "alt_text": "Business center with a large wooden table, chairs, and computers with printers.",
        "public_id": "019e8a00-9c8d-7367-98a8-0a08028659f9",
        "storage_key": "property/5738013569056768/019e8a00-9c8d-7367-98a8-0a08028659f9.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Utilize our convenient business center, complete with computers and printers, to stay productive while you're on the go.",
      "link": "",
      "alt_text": "Business center with a large wooden table, chairs, and computers with printers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_541d5c9f-e994-4334-8308-9be2a3780ac4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019e8a00-9b24-7469-9db0-cc0b15d4893b.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with shelves and hangers.",
        "public_id": "019e8a00-9b24-7469-9db0-cc0b15d4893b",
        "storage_key": "property/5738013569056768/019e8a00-9b24-7469-9db0-cc0b15d4893b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving and hanging space. Perfect for organizing your wardrobe and keeping your personal items tidy.",
      "link": "",
      "alt_text": "Empty walk-in closet with shelves and hangers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_339a3c19-9f7c-4707-bca3-8083bbfeaab0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019e8a00-9e32-7308-94d6-e6c8651a6877.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and bar seating.",
        "public_id": "019e8a00-9e32-7308-94d6-e6c8651a6877",
        "storage_key": "property/5738013569056768/019e8a00-9e32-7308-94d6-e6c8651a6877.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Discover the stunning, modern kitchen featuring granite countertops, stainless steel appliances, and convenient bar seating. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and bar seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0ace3f65-fdc5-4a99-80aa-f9de06748473",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019e8a00-9acc-7137-bcb7-637207bf07d0.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and wood-look flooring.",
        "public_id": "019e8a00-9acc-7137-bcb7-637207bf07d0",
        "storage_key": "property/5738013569056768/019e8a00-9acc-7137-bcb7-637207bf07d0.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed kitchen, featuring elegant granite countertops, a deep stainless steel sink, and a full suite of modern appliances. Enjoy the convenience of ample cabinet space and stylish wood-look flooring.",
      "link": "",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2853cbae-3030-4b5b-9d56-b464464f3210",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019e8a00-9944-76f3-9e1d-4d3d83044e57.webp",
      "image_media": {
        "alt_text": "Cardio machines in apartment gym.",
        "public_id": "019e8a00-9944-76f3-9e1d-4d3d83044e57",
        "storage_key": "property/5738013569056768/019e8a00-9944-76f3-9e1d-4d3d83044e57.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a variety of cardio equipment for a great workout.",
      "link": "",
      "alt_text": "Cardio machines in apartment gym.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_18b0e243-5c22-403f-9f9d-496e6e806bf2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019e8a00-9872-73fc-854c-d13ed36a418d.webp",
      "image_media": {
        "alt_text": "Clubhouse lounge area with a fireplace, seating, and a bar.",
        "public_id": "019e8a00-9872-73fc-854c-d13ed36a418d",
        "storage_key": "property/5738013569056768/019e8a00-9872-73fc-854c-d13ed36a418d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and socialize in our beautifully appointed clubhouse, featuring a cozy fireplace, ample seating, and a full-service bar.",
      "link": "",
      "alt_text": "Clubhouse lounge area with a fireplace, seating, and a bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3bbcb933-33b3-4805-b2ef-4ef3a941d362",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019e8a00-7b42-7508-a3d4-abfd62b02794.webp",
      "image_media": {
        "alt_text": "Dog park with playground equipment and benches, adjacent to apartment buildings and parking lot.",
        "public_id": "019e8a00-7b42-7508-a3d4-abfd62b02794",
        "storage_key": "property/5738013569056768/019e8a00-7b42-7508-a3d4-abfd62b02794.webp",
        "width": 3072,
        "height": 2301
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, complete with playground structures and comfortable seating for you and your furry friends.",
      "link": "",
      "alt_text": "Dog park with playground equipment and benches, adjacent to apartment buildings and parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dafdbbbc-1b25-423f-a11e-c53ff44f7542",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019e8a00-7ab9-73da-bdec-9302bd51b916.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
        "public_id": "019e8a00-7ab9-73da-bdec-9302bd51b916",
        "storage_key": "property/5738013569056768/019e8a00-7ab9-73da-bdec-9302bd51b916.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "This apartment kitchen features sleek stainless steel appliances, including a microwave, oven, and refrigerator, complemented by elegant granite countertops and white cabinetry.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_1d8cbbdb55c952806cea5df9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Tacos La Salsita",
      "poi_type": "Restaurants",
      "poi_address": "8802 Marbach Rd, San Antonio, TX 78227, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-75ad-74af-8cd6-01687a1a044f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-75ad-74af-8cd6-01687a1a044f",
        "storage_key": "property/5738013569056768/019f14f2-75ad-74af-8cd6-01687a1a044f.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11457156806120727803&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tacos-la-salsita",
      "poi_latitude": "29.4173034",
      "poi_longitude": "-98.6606591",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e41d-7668-b7b2-d1349c3adbeb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e41d-7668-b7b2-d1349c3adbeb",
        "storage_key": "property/5738013569056768/019f14f0-e41d-7668-b7b2-d1349c3adbeb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJfVSW1KpcXIYR-2TGnGn__54",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "taco_restaurant"
    },
    {
      "id": "ec_7cc03ca2791b0f41669373fb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "El Bucanero - Marbach",
      "poi_type": "Restaurants",
      "poi_address": "8300 Marbach Rd, San Antonio, TX 78227, USA",
      "poi_short_description": "Casual seafood eatery that also serves Mexican dishes, plus beer and wine.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-761b-75bc-be53-c7e0d7bdf4a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-761b-75bc-be53-c7e0d7bdf4a4",
        "storage_key": "property/5738013569056768/019f14f2-761b-75bc-be53-c7e0d7bdf4a4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://el-bucanero.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6747749998810803745&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-bucanero---marbach",
      "poi_latitude": "29.4167616",
      "poi_longitude": "-98.6551733",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 210-645-7337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e41d-7668-b7b2-d1349c3adbeb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e41d-7668-b7b2-d1349c3adbeb",
        "storage_key": "property/5738013569056768/019f14f0-e41d-7668-b7b2-d1349c3adbeb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQTSdOqpcXIYRIa5CcN_SpF0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_a31b48a08cf6fd7311629905",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Los Cabos Marbach",
      "poi_type": "Restaurants",
      "poi_address": "7310 Marbach Rd, San Antonio, TX 78227, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-766b-70b6-8c91-0ea05d4ee4a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-766b-70b6-8c91-0ea05d4ee4a6",
        "storage_key": "property/5738013569056768/019f14f2-766b-70b6-8c91-0ea05d4ee4a6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://loscabosmarbachtx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1453349543991298238&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "los-cabos-marbach",
      "poi_latitude": "29.4174572",
      "poi_longitude": "-98.6342744",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-726-2274",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e41d-7668-b7b2-d1349c3adbeb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e41d-7668-b7b2-d1349c3adbeb",
        "storage_key": "property/5738013569056768/019f14f0-e41d-7668-b7b2-d1349c3adbeb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_Z1FP55cXIYRvsgTyLVVKxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_d5dd38f476d4831a297a9dfd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Gilberts Mexican Restaurant LLC",
      "poi_type": "Restaurants",
      "poi_address": "8138 Marbach Rd suite 102, San Antonio, TX 78227, USA",
      "poi_short_description": "Informal destination serving a variety of classic Mexican recipes in a simple setting.",
      "poi_long_description": "Informal destination serving a variety of classic Mexican recipes in a simple setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-74f6-7390-b3c7-9336ed995c25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-74f6-7390-b3c7-9336ed995c25",
        "storage_key": "property/5738013569056768/019f14f2-74f6-7390-b3c7-9336ed995c25.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.gilbertsmexicanrestaurantllctx.com/order",
      "poi_directions_map_url": "https://maps.google.com/?cid=16638840311864822414&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gilberts-mexican-restaurant-llc",
      "poi_latitude": "29.4163081",
      "poi_longitude": "-98.6482112",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-673-2990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e41d-7668-b7b2-d1349c3adbeb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e41d-7668-b7b2-d1349c3adbeb",
        "storage_key": "property/5738013569056768/019f14f0-e41d-7668-b7b2-d1349c3adbeb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbYvR5adcXIYRjgondxsJ6eY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_9efdb34a3e8d6050c546c420",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Mony’s café",
      "poi_type": "Restaurants",
      "poi_address": "7504 Marbach Rd, San Antonio, TX 78227, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-7156-71fb-b103-b87805299669.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-7156-71fb-b103-b87805299669",
        "storage_key": "property/5738013569056768/019f14f2-7156-71fb-b103-b87805299669.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8962362455093948701&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "monys-caf",
      "poi_latitude": "29.41752839999999",
      "poi_longitude": "-98.6362923",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-674-1398",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e41d-7668-b7b2-d1349c3adbeb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e41d-7668-b7b2-d1349c3adbeb",
        "storage_key": "property/5738013569056768/019f14f0-e41d-7668-b7b2-d1349c3adbeb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2YkDj_RdXIYRHTEsFCu1YHw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_41e1ff91bd21f73fe7a418f2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Trendy Pets Grooming Salon",
      "poi_type": "Restaurants",
      "poi_address": "7708 Marbach Rd Ste 5, San Antonio, TX 78227, USA",
      "poi_short_description": "Dog grooming and daycare for all breeds, plus baths and nail trimming.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-7874-7709-959e-90e1e304d41c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-7874-7709-959e-90e1e304d41c",
        "storage_key": "property/5738013569056768/019f14f2-7874-7709-959e-90e1e304d41c.webp",
        "width": 562,
        "height": 1280
      },
      "poi_business_url": "http://trendypetsgrooming.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16137939642438370994&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trendy-pets-grooming-salon",
      "poi_latitude": "29.4174039",
      "poi_longitude": "-98.6404654",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-437-1780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e430-76fa-8c15-776feffd3990",
        "storage_key": "property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX7DgXJ9dXIYRssY7Mpp69d8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pet_care"
    },
    {
      "id": "ec_0ad9bde920775b7b3c6e2b46",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "8221 Marbach Rd, San Antonio, TX 78227, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-7150-756f-acb0-5051d556735d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-7150-756f-acb0-5051d556735d",
        "storage_key": "property/5738013569056768/019f14f2-7150-756f-acb0-5051d556735d.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/tx/marbach-at-410?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=6009543881649415322&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "29.4183047",
      "poi_longitude": "-98.6533469",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-673-2777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e41d-7668-b7b2-d1349c3adbeb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e41d-7668-b7b2-d1349c3adbeb",
        "storage_key": "property/5738013569056768/019f14f0-e41d-7668-b7b2-d1349c3adbeb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdWr5cqlcXIYRmuTVB1IwZlM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_277886ecc59efd1c51ed59e6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "IHOP",
      "poi_type": "Restaurants",
      "poi_address": "1500 SW Loop 410, San Antonio, TX 78227, USA",
      "poi_short_description": "Long-standing chain serving a wide variety of pancakes & other American breakfast & diner fare.",
      "poi_long_description": "Long-standing chain serving a wide variety of pancakes & other American breakfast & diner fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-716e-77be-a394-36d596c6f9a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-716e-77be-a394-36d596c6f9a1",
        "storage_key": "property/5738013569056768/019f14f2-716e-77be-a394-36d596c6f9a1.webp",
        "width": 1280,
        "height": 774
      },
      "poi_business_url": "https://restaurants.ihop.com/en-us/tx/san-antonio/breakfast-1500-sw-loop-410-1955?utm_source=google&utm_medium=organic&utm_campaign=google_my_business&utm_term=1955&utm_content=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=16141216112860395726&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ihop",
      "poi_latitude": "29.4191256",
      "poi_longitude": "-98.648673",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-675-7775",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e41d-7668-b7b2-d1349c3adbeb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e41d-7668-b7b2-d1349c3adbeb",
        "storage_key": "property/5738013569056768/019f14f0-e41d-7668-b7b2-d1349c3adbeb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJH5KG_6VcXIYRzvja6YgeAeA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "ec_d64c89e0d0aa829bede1312b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Dairy Queen",
      "poi_type": "Restaurants",
      "poi_address": "7118 Marbach Rd, San Antonio, TX 78227, USA",
      "poi_short_description": "Soft-serve ice cream & signature shakes top the menu at this classic burger & fries fast-food chain.",
      "poi_long_description": "Soft-serve ice cream & signature shakes top the menu at this classic burger & fries fast-food chain.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-7155-772b-ac10-975704864962.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-7155-772b-ac10-975704864962",
        "storage_key": "property/5738013569056768/019f14f2-7155-772b-ac10-975704864962.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.dairyqueen.com/en-us/locations/tx/san-antonio/7118-marbach-rd/14559/?y_source=1_MjkzMzk0MDgtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=2349351927700365032&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dairy-queen",
      "poi_latitude": "29.4173929",
      "poi_longitude": "-98.6305961",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-673-7269",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e41d-7668-b7b2-d1349c3adbeb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e41d-7668-b7b2-d1349c3adbeb",
        "storage_key": "property/5738013569056768/019f14f0-e41d-7668-b7b2-d1349c3adbeb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxZtYl51cXIYR6J71fiGTmiA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_401f45e1f4eb0aabc6179fde",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Little Caesars Pizza",
      "poi_type": "Restaurants",
      "poi_address": "8733 Marbach Rd Suite 101, San Antonio, TX 78227, USA",
      "poi_short_description": "Carry-out chain featuring chicken wings, signature breadsticks & pizza tossed from housemade dough.",
      "poi_long_description": "Carry-out chain featuring chicken wings, signature breadsticks & pizza tossed from housemade dough.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-70eb-75af-90d4-a41ee0f08283.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-70eb-75af-90d4-a41ee0f08283",
        "storage_key": "property/5738013569056768/019f14f2-70eb-75af-90d4-a41ee0f08283.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://littlecaesars.com/en-us/store/2206",
      "poi_directions_map_url": "https://maps.google.com/?cid=843949479044043457&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-caesars-pizza",
      "poi_latitude": "29.4182594",
      "poi_longitude": "-98.6572941",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 210-674-3219",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e41d-7668-b7b2-d1349c3adbeb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e41d-7668-b7b2-d1349c3adbeb",
        "storage_key": "property/5738013569056768/019f14f0-e41d-7668-b7b2-d1349c3adbeb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCx0GCKtcXIYRwdLLapRPtgs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_77a4d93263abf87cf58d7daa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Domino's Pizza",
      "poi_type": "Restaurants",
      "poi_address": "7315 Marbach Rd, San Antonio, TX 78227, USA",
      "poi_short_description": "Delivery, carryout & dine-in chain offering a wide range of pizzas, plus a variety of other dishes & sides.",
      "poi_long_description": "Delivery, carryout & dine-in chain offering a wide range of pizzas, plus a variety of other dishes & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-797e-710e-bd03-bcb78cb2dca3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-797e-710e-bd03-bcb78cb2dca3",
        "storage_key": "property/5738013569056768/019f14f2-797e-710e-bd03-bcb78cb2dca3.webp",
        "width": 1280,
        "height": 632
      },
      "poi_business_url": "https://www.dominos.com/en/?utm_source=google&utm_medium=loclist&utm_campaign=localmaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=9126569808891552892&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dominos-pizza",
      "poi_latitude": "29.4180586",
      "poi_longitude": "-98.6342803",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-673-6840",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e430-76fa-8c15-776feffd3990",
        "storage_key": "property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2Ur0QZ5cXIYRfCTJ9OIWqH4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_delivery"
    },
    {
      "id": "ec_9917af306bd4cb60def436da",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Beijing Express",
      "poi_type": "Restaurants",
      "poi_address": "8003 Marbach Rd, San Antonio, TX 78227, USA",
      "poi_short_description": "Basic destination serving a range of classic Chinese recipes in a low-key setting.",
      "poi_long_description": "Basic destination serving a range of classic Chinese recipes in a low-key setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-7c39-77cb-9681-f46b0afb8c5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-7c39-77cb-9681-f46b0afb8c5f",
        "storage_key": "property/5738013569056768/019f14f2-7c39-77cb-9681-f46b0afb8c5f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.beijingexpresssanantonio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2996131145170199631&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beijing-express",
      "poi_latitude": "29.4180928",
      "poi_longitude": "-98.6454905",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-674-7728",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e41d-7668-b7b2-d1349c3adbeb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e41d-7668-b7b2-d1349c3adbeb",
        "storage_key": "property/5738013569056768/019f14f0-e41d-7668-b7b2-d1349c3adbeb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ4DoHqdcXIYRT6RaAGdllCk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "ec_0f95ae63864830d3a9645cdf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Taco Bell",
      "poi_type": "Restaurants",
      "poi_address": "8288 Marbach Rd, San Antonio, TX 78227, USA",
      "poi_short_description": "Fast-food chain serving Mexican-inspired fare such as tacos, quesadillas & nachos.",
      "poi_long_description": "Fast-food chain serving Mexican-inspired fare such as tacos, quesadillas & nachos.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-7ea8-738d-847d-7ef022b4bd35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-7ea8-738d-847d-7ef022b4bd35",
        "storage_key": "property/5738013569056768/019f14f2-7ea8-738d-847d-7ef022b4bd35.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.tacobell.com/tx/san-antonio/8288-marbach-rd.html?utm_source=yext&utm_campaign=googlelistings&utm_medium=referral&utm_term=031395&utm_content=website&y_source=1_NjE0MTk5Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=879941455653606470&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taco-bell",
      "poi_latitude": "29.4174467",
      "poi_longitude": "-98.6537929",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 210-686-5885",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e41d-7668-b7b2-d1349c3adbeb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e41d-7668-b7b2-d1349c3adbeb",
        "storage_key": "property/5738013569056768/019f14f0-e41d-7668-b7b2-d1349c3adbeb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJx2C1nKlcXIYRRpRffxcuNgw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_b5753195f75d15491dd1af93",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "El Tequila",
      "poi_type": "Restaurants",
      "poi_address": "7628 Marbach Rd, San Antonio, TX 78227, USA",
      "poi_short_description": "Informal eatery serving a variety of traditional Mexican fare in a simple environment.",
      "poi_long_description": "Informal eatery serving a variety of traditional Mexican fare in a simple environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-80ac-747b-92dd-388009f7db2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-80ac-747b-92dd-388009f7db2b",
        "storage_key": "property/5738013569056768/019f14f2-80ac-747b-92dd-388009f7db2b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12648593708309477397&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-tequila",
      "poi_latitude": "29.4175884",
      "poi_longitude": "-98.6392135",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-673-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e41d-7668-b7b2-d1349c3adbeb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e41d-7668-b7b2-d1349c3adbeb",
        "storage_key": "property/5738013569056768/019f14f0-e41d-7668-b7b2-d1349c3adbeb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_fDWPqBcXIYRFfgGbPbUiK8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_1d998e0be19b2e77eef730d5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Taqueria Jalisco #7",
      "poi_type": "Restaurants",
      "poi_address": "7504 Marbach Rd, San Antonio, TX 78227, USA",
      "poi_short_description": "Compact spot dishing up a selection of familiar Mexican grub in a basic setting.",
      "poi_long_description": "Compact spot dishing up a selection of familiar Mexican grub in a basic setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-7c39-77cb-9681-f190420fc560.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-7c39-77cb-9681-f190420fc560",
        "storage_key": "property/5738013569056768/019f14f2-7c39-77cb-9681-f190420fc560.webp",
        "width": 1280,
        "height": 1119
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10761408042248503547&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taqueria-jalisco-7",
      "poi_latitude": "29.41752839999999",
      "poi_longitude": "-98.6362923",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-674-1398",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e41d-7668-b7b2-d1349c3adbeb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e41d-7668-b7b2-d1349c3adbeb",
        "storage_key": "property/5738013569056768/019f14f0-e41d-7668-b7b2-d1349c3adbeb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUx5KuZ9cXIYR-wBBGZkzWJU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_1e90cb6cda7a52fd6b955dfa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "H-E-B plus!",
      "poi_type": "Shopping & Retail",
      "poi_address": "8219 Marbach Rd, San Antonio, TX 78227, USA",
      "poi_short_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_long_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-21f7-75dc-a600-c3ea71088863.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-21f7-75dc-a600-c3ea71088863",
        "storage_key": "property/5738013569056768/019f14f0-21f7-75dc-a600-c3ea71088863.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/san-antonio/marbach-and-410-h-e-b-plus--613?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=2452901904169700394&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b-plus",
      "poi_latitude": "29.4199914",
      "poi_longitude": "-98.6526562",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-673-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e42f-7488-ab85-3e68e32faf90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e42f-7488-ab85-3e68e32faf90",
        "storage_key": "property/5738013569056768/019f14f0-e42f-7488-ab85-3e68e32faf90.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUeFtCKlcXIYRKgzqKkl1CiI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_b1368befb57489e601c5be81",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "7239 SW Loop 410, San Antonio, TX 78242, USA",
      "poi_short_description": "Department store chain offering a wide range of products including furniture, clothing, and groceries.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-81d3-756d-b2c2-8f0e113c3bff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-81d3-756d-b2c2-8f0e113c3bff",
        "storage_key": "property/5738013569056768/019f14f2-81d3-756d-b2c2-8f0e113c3bff.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/999-san-antonio-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=3616822619189499382&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "29.3593771",
      "poi_longitude": "-98.6345972",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 210-247-5905",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e471-7301-a811-0f4a60237eff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e471-7301-a811-0f4a60237eff",
        "storage_key": "property/5738013569056768/019f14f0-e471-7301-a811-0f4a60237eff.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJbfVhL-ZaXIYR9lVjaAKJMTI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_169075ae9d0e1ce02b5579a2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "7103 Marbach Rd, San Antonio, TX 78227, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-80a5-72ec-a94f-4e25e0e4825d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-80a5-72ec-a94f-4e25e0e4825d",
        "storage_key": "property/5738013569056768/019f14f2-80a5-72ec-a94f-4e25e0e4825d.webp",
        "width": 1280,
        "height": 554
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-7103+marbach+rd-san+antonio-tx-78227/id=3563",
      "poi_directions_map_url": "https://maps.google.com/?cid=15506384911370783225&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "29.4181295",
      "poi_longitude": "-98.6300986",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-675-6612",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e430-76fa-8c15-776feffd3990",
        "storage_key": "property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCQAcpJ1cXIYR-Ym7qOu-Mdc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_f91b759bc56db4a79c87309a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Poco Loco Supermercado #15",
      "poi_type": "Shopping & Retail",
      "poi_address": "7002 Marbach Rd #5, San Antonio, TX 78227, USA",
      "poi_short_description": "Grocery chain featuring produce, meat, and a bakery, plus a restroom.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-8231-71ea-b552-deb6c825f9a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-8231-71ea-b552-deb6c825f9a5",
        "storage_key": "property/5738013569056768/019f14f2-8231-71ea-b552-deb6c825f9a5.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.pocolocosupermercado.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12257823875315981790&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "poco-loco-supermercado-15",
      "poi_latitude": "29.4174106",
      "poi_longitude": "-98.6276438",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-645-9771",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e42f-7488-ab85-3e68e32faf90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e42f-7488-ab85-3e68e32faf90",
        "storage_key": "property/5738013569056768/019f14f0-e42f-7488-ab85-3e68e32faf90.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuc89tIJcXIYR3t2Cr96JHKo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_9fbbb79eafb3008245d4ede7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Family Dollar",
      "poi_type": "Shopping & Retail",
      "poi_address": "8738 Marbach Rd, San Antonio, TX 78227, USA",
      "poi_short_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_long_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-835a-714b-9883-270dee6ef574.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-835a-714b-9883-270dee6ef574",
        "storage_key": "property/5738013569056768/019f14f2-835a-714b-9883-270dee6ef574.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.familydollar.com/tx/san-antonio/8738-marbach-rd?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=11048986091686559895&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "family-dollar",
      "poi_latitude": "29.41717879999999",
      "poi_longitude": "-98.65822690000002",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 210-998-7316",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e471-7301-a811-0f4a60237eff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e471-7301-a811-0f4a60237eff",
        "storage_key": "property/5738013569056768/019f14f0-e471-7301-a811-0f4a60237eff.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJGV8S4qpcXIYRl4A1c0_iVZk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_3252c835b9b9016ec6a0e79c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "7815 Marbach Rd, San Antonio, TX 78227, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-8416-715d-9b84-d6267495dba2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-8416-715d-9b84-d6267495dba2",
        "storage_key": "property/5738013569056768/019f14f2-8416-715d-9b84-d6267495dba2.webp",
        "width": 480,
        "height": 720
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/tx/san-antonio/3397",
      "poi_directions_map_url": "https://maps.google.com/?cid=11283748478844668114&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "29.4183944",
      "poi_longitude": "-98.643171",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-741-7610",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e471-7301-a811-0f4a60237eff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e471-7301-a811-0f4a60237eff",
        "storage_key": "property/5738013569056768/019f14f0-e471-7301-a811-0f4a60237eff.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZ6lp11dbXIYR0ghkKHXtl5w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_2500418d572dc98b12d5d8a9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "H-E-B Fuel",
      "poi_type": "Shopping & Retail",
      "poi_address": "8219 Marbach Rd, San Antonio, TX 78227, USA",
      "poi_short_description": "Gas station chain featuring everyday low prices, plus a car wash and propane exchange.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-85e2-703f-8f9c-7d648b54f0c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-85e2-703f-8f9c-7d648b54f0c9",
        "storage_key": "property/5738013569056768/019f14f2-85e2-703f-8f9c-7d648b54f0c9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/san-antonio/marbach-and-410-h-e-b-plus!-613?utm_source=google&utm_medium=organic&utm_campaign=gmb_fuel",
      "poi_directions_map_url": "https://maps.google.com/?cid=5801029446003335289&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b-fuel",
      "poi_latitude": "29.4182436",
      "poi_longitude": "-98.6516965",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 210-673-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f3-02e4-73de-8f65-b15d87e8ac5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f3-02e4-73de-8f65-b15d87e8ac5b",
        "storage_key": "property/5738013569056768/019f14f3-02e4-73de-8f65-b15d87e8ac5b.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJk3TB_ahcXIYReSCcxItlgVA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "ec_82f172e7776009d8ce5bbae7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Rent-A-Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "8236 Marbach Rd, San Antonio, TX 78227, USA",
      "poi_short_description": "Chain offering rental or purchase options on items such as furniture, electronics, and appliances.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-853e-715f-a5ba-27625e3e5505.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-853e-715f-a5ba-27625e3e5505",
        "storage_key": "property/5738013569056768/019f14f2-853e-715f-a5ba-27625e3e5505.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.rentacenter.com/location/3751/?utm_source=google&utm_medium=organic&utm_campaign=localmaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=10741258413441209742&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rent-a-center",
      "poi_latitude": "29.416752",
      "poi_longitude": "-98.651529",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-673-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e430-76fa-8c15-776feffd3990",
        "storage_key": "property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn1aaB6lcXIYRjtXWDZ6dEJU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_1f5d13f10a1c0665ebc9ba6f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Gabriel's Liquors",
      "poi_type": "Shopping & Retail",
      "poi_address": "6915 S Zarzamora St #109, San Antonio, TX 78224, USA",
      "poi_short_description": "Retailer stocking a wide selection of beer, wine & spirits from popular brands, plus cigars.",
      "poi_long_description": "Retailer stocking a wide selection of beer, wine & spirits from popular brands, plus cigars.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-8744-7542-994d-bed07ba7ac81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-8744-7542-994d-bed07ba7ac81",
        "storage_key": "property/5738013569056768/019f14f2-8744-7542-994d-bed07ba7ac81.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.gabrielsliquor.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8499078916689297730&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gabriels-liquors",
      "poi_latitude": "29.3583501",
      "poi_longitude": "-98.5353061",
      "poi_miles_from_property": "12.0 mi",
      "poi_walking_minutes": "4 hours 24 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 210-924-7499",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e471-7301-a811-0f4a60237eff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e471-7301-a811-0f4a60237eff",
        "storage_key": "property/5738013569056768/019f14f0-e471-7301-a811-0f4a60237eff.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJE2nPrLZZXIYRQgFHoz7L8nU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "liquor_store"
    },
    {
      "id": "ec_8b76c99d026f1a32db1cc194",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Action Pawn",
      "poi_type": "Shopping & Retail",
      "poi_address": "8139 Marbach Rd, San Antonio, TX 78227, USA",
      "poi_short_description": "Pawnshop chain buying and selling firearms, tools, and other items, plus offering layaway plans.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-8642-766a-ae5a-a0e93cc6399b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-8642-766a-ae5a-a0e93cc6399b",
        "storage_key": "property/5738013569056768/019f14f2-8642-766a-ae5a-a0e93cc6399b.webp",
        "width": 1250,
        "height": 834
      },
      "poi_business_url": "https://www.firstcash.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15225096321905449658&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "action-pawn",
      "poi_latitude": "29.4183273",
      "poi_longitude": "-98.6484527",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-677-8580",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e471-7301-a811-0f4a60237eff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e471-7301-a811-0f4a60237eff",
        "storage_key": "property/5738013569056768/019f14f0-e471-7301-a811-0f4a60237eff.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJaxHyLKZcXIYRutpHUnBoStM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_204d4e14307c41f9b6725639",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "John Jay High School",
      "poi_type": "Education",
      "poi_address": "7611 Marbach Rd, San Antonio, TX 78227, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-8868-72d5-a68b-364454d73257.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-8868-72d5-a68b-364454d73257",
        "storage_key": "property/5738013569056768/019f14f2-8868-72d5-a68b-364454d73257.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://nisd.net/jay/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4692771767847319479&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "john-jay-high-school",
      "poi_latitude": "29.4184088",
      "poi_longitude": "-98.6407119",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-397-2700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e418-7223-b703-6a65118c5bb2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e418-7223-b703-6a65118c5bb2",
        "storage_key": "property/5738013569056768/019f14f0-e418-7223-b703-6a65118c5bb2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJI3gppaFcXIYRt3eFOg8TIEE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_724f87d016ef2c69689a2145",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "J. B. Passmore Elementary School",
      "poi_type": "Education",
      "poi_address": "570 Pinn Rd, San Antonio, TX 78227, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-87fc-75dd-853d-0604926b3ffd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-87fc-75dd-853d-0604926b3ffd",
        "storage_key": "property/5738013569056768/019f14f2-87fc-75dd-853d-0604926b3ffd.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://nisd.net/passmore/",
      "poi_directions_map_url": "https://maps.google.com/?cid=261919972644788592&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "j-b-passmore-elementary-school",
      "poi_latitude": "29.4304937",
      "poi_longitude": "-98.6227331",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-397-0500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e418-7223-b703-6a65118c5bb2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e418-7223-b703-6a65118c5bb2",
        "storage_key": "property/5738013569056768/019f14f0-e418-7223-b703-6a65118c5bb2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkdf5FY9cXIYRcJkS0dOGogM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_d97c16bc5d6484b480d741b9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Cable Elementary School",
      "poi_type": "Education",
      "poi_address": "1706 Pinn Rd, San Antonio, TX 78227, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-8942-7028-9590-a0ada2918d6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-8942-7028-9590-a0ada2918d6e",
        "storage_key": "property/5738013569056768/019f14f2-8942-7028-9590-a0ada2918d6e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.nisd.net/schools/info/101",
      "poi_directions_map_url": "https://maps.google.com/?cid=15497402544249966269&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cable-elementary-school",
      "poi_latitude": "29.4143402",
      "poi_longitude": "-98.6232896",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-397-2850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e418-7223-b703-6a65118c5bb2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e418-7223-b703-6a65118c5bb2",
        "storage_key": "property/5738013569056768/019f14f0-e418-7223-b703-6a65118c5bb2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJL4QNLHxbXIYRvQ5BV4HVEdc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_899980b06ce8d899d6760668",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Meadow Village Elementary School",
      "poi_type": "Education",
      "poi_address": "1406 Meadow Way Dr, San Antonio, TX 78227, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-8993-72df-8e63-d70ebb16c550.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-8993-72df-8e63-d70ebb16c550",
        "storage_key": "property/5738013569056768/019f14f2-8993-72df-8e63-d70ebb16c550.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://nisd.net/meadowvillage/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10646208162527439565&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meadow-village-elementary-school",
      "poi_latitude": "29.422951",
      "poi_longitude": "-98.64377",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-397-0650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e418-7223-b703-6a65118c5bb2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e418-7223-b703-6a65118c5bb2",
        "storage_key": "property/5738013569056768/019f14f0-e418-7223-b703-6a65118c5bb2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZZkijaNcXIYRzepP9OrtvpM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_2c56d78552e97fbc1a028d51",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Anson Jones Middle School",
      "poi_type": "Education",
      "poi_address": "1256 Pinn Rd, San Antonio, TX 78227, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.nisd.net/jones",
      "poi_directions_map_url": "https://maps.google.com/?cid=6825844769676903321&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anson-jones-middle-school",
      "poi_latitude": "29.4223364",
      "poi_longitude": "-98.6229372",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-397-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e418-7223-b703-6a65118c5bb2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e418-7223-b703-6a65118c5bb2",
        "storage_key": "property/5738013569056768/019f14f0-e418-7223-b703-6a65118c5bb2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpdnyVoFcXIYRmcOMNKdFul4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_e4dd440e406507f3d906cb4a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Sam Rayburn Middle School",
      "poi_type": "Education",
      "poi_address": "1400 Cedarhurst Dr, San Antonio, TX 78227, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-8be4-7381-9743-35d00766b12d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-8be4-7381-9743-35d00766b12d",
        "storage_key": "property/5738013569056768/019f14f2-8be4-7381-9743-35d00766b12d.webp",
        "width": 1280,
        "height": 735
      },
      "poi_business_url": "http://nisd.net/rayburn/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5937064965084858360&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sam-rayburn-middle-school",
      "poi_latitude": "29.3832027",
      "poi_longitude": "-98.6395506",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 210-397-2150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e418-7223-b703-6a65118c5bb2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e418-7223-b703-6a65118c5bb2",
        "storage_key": "property/5738013569056768/019f14f0-e418-7223-b703-6a65118c5bb2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJg0OMWz1bXIYR-MdMPCGxZFI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_872ae4fe0b9051c2cc488b9b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "E. M. Pease Middle School",
      "poi_type": "Education",
      "poi_address": "201 Hunt Ln, San Antonio, TX 78245, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-8cab-767d-8543-8fa8a72adfbf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-8cab-767d-8543-8fa8a72adfbf",
        "storage_key": "property/5738013569056768/019f14f2-8cab-767d-8543-8fa8a72adfbf.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://nisd.net/pease/",
      "poi_directions_map_url": "https://maps.google.com/?cid=640371480942429855&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "e-m-pease-middle-school",
      "poi_latitude": "29.43405719999999",
      "poi_longitude": "-98.6691074",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-397-2950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e418-7223-b703-6a65118c5bb2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e418-7223-b703-6a65118c5bb2",
        "storage_key": "property/5738013569056768/019f14f0-e418-7223-b703-6a65118c5bb2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJWzG7WUhDXIYRn0bdFXgO4wg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_d89fe54e15ae136a541acb8b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Marbach Christian Child Development Center",
      "poi_type": "Education",
      "poi_address": "8023 Marbach Rd, San Antonio, TX 78227, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-8edf-710c-bcc8-fa763517db4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-8edf-710c-bcc8-fa763517db4c",
        "storage_key": "property/5738013569056768/019f14f2-8edf-710c-bcc8-fa763517db4c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.marbachchristiancdc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16379848593150017834&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marbach-christian-child-development-center",
      "poi_latitude": "29.41845",
      "poi_longitude": "-98.6465234",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-673-4538",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e418-7223-b703-6a65118c5bb2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e418-7223-b703-6a65118c5bb2",
        "storage_key": "property/5738013569056768/019f14f0-e418-7223-b703-6a65118c5bb2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJwVI94xNdXIYRKoFj5YLpUOM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_92fd8acae85b03e677490a30",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "La Petite Academy on Marbach",
      "poi_type": "Education",
      "poi_address": "8796 Marbach Rd, San Antonio, TX 78227, USA",
      "poi_short_description": "Child-care facility focusing on preschool through school-age programs that also offers summer camps.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-9564-7439-be7c-435b37135189.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-9564-7439-be7c-435b37135189",
        "storage_key": "property/5738013569056768/019f14f2-9564-7439-be7c-435b37135189.webp",
        "width": 1280,
        "height": 1024
      },
      "poi_business_url": "https://www.lapetite.com/your-local-school/san-antonio-tx-7633/?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=7633",
      "poi_directions_map_url": "https://maps.google.com/?cid=3340610375559428033&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-petite-academy-on-marbach",
      "poi_latitude": "29.4174747",
      "poi_longitude": "-98.6587241",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 877-271-6466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e418-7223-b703-6a65118c5bb2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e418-7223-b703-6a65118c5bb2",
        "storage_key": "property/5738013569056768/019f14f0-e418-7223-b703-6a65118c5bb2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_Wo8IKtcXIYRwTc08G87XC4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_e931d377db2e49780384f00f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Texas A&M University-San Antonio",
      "poi_type": "Education",
      "poi_address": "One University Way, San Antonio, TX 78224, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-922e-7212-8116-552718c13384.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-922e-7212-8116-552718c13384",
        "storage_key": "property/5738013569056768/019f14f2-922e-7212-8116-552718c13384.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.tamusa.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7914302810279121137&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-am-university-san-antonio",
      "poi_latitude": "29.3042745",
      "poi_longitude": "-98.5247016",
      "poi_miles_from_property": "16.3 mi",
      "poi_walking_minutes": "6 hours 0 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 210-784-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e418-7223-b703-6a65118c5bb2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e418-7223-b703-6a65118c5bb2",
        "storage_key": "property/5738013569056768/019f14f0-e418-7223-b703-6a65118c5bb2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJA5bzDWJXXIYR8RCQY3lA1W0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_58dd35424596a0a522d71d4e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Santikos Westlakes",
      "poi_type": "Entertainment",
      "poi_address": "1255 SW Loop 410, San Antonio, TX 78227, USA",
      "poi_short_description": "Movie theater with comfy reclining seats, gourmet dining, and a self-serve station for popcorn and drinks.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-92e2-709e-b47d-2a19e92b7cb0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-92e2-709e-b47d-2a19e92b7cb0",
        "storage_key": "property/5738013569056768/019f14f2-92e2-709e-b47d-2a19e92b7cb0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.santikos.com/san-antonio/westlakes/theater-info/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4687952116231842377&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "santikos-westlakes",
      "poi_latitude": "29.426229",
      "poi_longitude": "-98.6508977",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 877-691-0734",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f3-02c0-731e-a056-a83537fbef71.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f3-02c0-731e-a056-a83537fbef71",
        "storage_key": "property/5738013569056768/019f14f3-02c0-731e-a056-a83537fbef71.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ35NBw69cXIYRSSoKpJzzDkE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_af5bf3ca60f4a7ec7d086999",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Peter Piper Pizza",
      "poi_type": "Entertainment",
      "poi_address": "8250 Marbach Rd, San Antonio, TX 78227, USA",
      "poi_short_description": "Lively, kid-oriented chain featuring pizza & wings along with dozens of arcade games.",
      "poi_long_description": "Lively, kid-oriented chain featuring pizza & wings along with dozens of arcade games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-94e4-7468-a8ec-3eed87758f38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-94e4-7468-a8ec-3eed87758f38",
        "storage_key": "property/5738013569056768/019f14f2-94e4-7468-a8ec-3eed87758f38.webp",
        "width": 720,
        "height": 540
      },
      "poi_business_url": "https://locations.peterpiperpizza.com/tx/sanantonio/8250-marbach-road?utm_source=Google&utm_medium=Rio",
      "poi_directions_map_url": "https://maps.google.com/?cid=13579476120341301374&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "peter-piper-pizza",
      "poi_latitude": "29.4168688",
      "poi_longitude": "-98.6522108",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 210-674-7008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e41d-7668-b7b2-d1349c3adbeb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e41d-7668-b7b2-d1349c3adbeb",
        "storage_key": "property/5738013569056768/019f14f0-e41d-7668-b7b2-d1349c3adbeb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1UqUqqlcXIYRfsjXlJX9c7w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_e69ca3d19b3741d60ff4e44a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Traders Village San Antonio",
      "poi_type": "Entertainment",
      "poi_address": "9333 SW Loop 410, San Antonio, TX 78242, USA",
      "poi_short_description": "Massive outdoor flea market with shopping, special events, rides & food vendors.",
      "poi_long_description": "Massive outdoor flea market with shopping, special events, rides & food vendors.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-9bf0-716e-a320-617e6dea7d94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-9bf0-716e-a320-617e6dea7d94",
        "storage_key": "property/5738013569056768/019f14f2-9bf0-716e-a320-617e6dea7d94.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.tradersvillage.com/san-antonio/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2915387698780824972&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "traders-village-san-antonio",
      "poi_latitude": "29.3314605",
      "poi_longitude": "-98.6259644",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 210-623-8383",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e471-7301-a811-0f4a60237eff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e471-7301-a811-0f4a60237eff",
        "storage_key": "property/5738013569056768/019f14f0-e471-7301-a811-0f4a60237eff.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJzWXFgI5aXIYRjOVfaKqJdSg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "flea_market"
    },
    {
      "id": "ec_cb3efa8f25985a328fb73b12",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Morgan's Wonderland",
      "poi_type": "Entertainment",
      "poi_address": "5223 David Edwards Dr, San Antonio, TX 78233, USA",
      "poi_short_description": "Amusement center with acres of themed areas, rides & attractions for individuals with special needs.",
      "poi_long_description": "Amusement center with acres of themed areas, rides & attractions for individuals with special needs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-a109-72f7-be69-90bcaf2dd21d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-a109-72f7-be69-90bcaf2dd21d",
        "storage_key": "property/5738013569056768/019f14f2-a109-72f7-be69-90bcaf2dd21d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.morganswonderland.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13026522371191900116&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "morgans-wonderland",
      "poi_latitude": "29.5391049",
      "poi_longitude": "-98.3926044",
      "poi_miles_from_property": "22.9 mi",
      "poi_walking_minutes": "8 hours 36 mins",
      "poi_biking_minutes": "2 hours 16 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 210-495-5888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e430-76fa-8c15-776feffd3990",
        "storage_key": "property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXQ1t26aMXIYR1IeSQRSBx7Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_ec16b6af8b713700c0f02384",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "SeaWorld San Antonio",
      "poi_type": "Entertainment",
      "poi_address": "10500 SeaWorld Dr, San Antonio, TX 78251, USA",
      "poi_short_description": "Marine life shows, thrill rides, aquariums & up-close encounters with dolphins, penguins & more.",
      "poi_long_description": "Marine life shows, thrill rides, aquariums & up-close encounters with dolphins, penguins & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-4203-70a8-93a0-5a5e426c3c48.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-4203-70a8-93a0-5a5e426c3c48",
        "storage_key": "property/5738013569056768/019f14f0-4203-70a8-93a0-5a5e426c3c48.webp",
        "width": 1280,
        "height": 952
      },
      "poi_business_url": "https://seaworld.com/san-antonio?utm_source=google&utm_medium=organic&utm_campaign=gbp_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=8854466051154083971&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seaworld-san-antonio",
      "poi_latitude": "29.4562822",
      "poi_longitude": "-98.6999612",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 210-520-4732",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e430-76fa-8c15-776feffd3990",
        "storage_key": "property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc9c70gFDXIYRg4DL5vVh4Xo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_affee78b252021fe76df277c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Six Flags Fiesta Texas",
      "poi_type": "Entertainment",
      "poi_address": "San Antonio, TX 78257, USA",
      "poi_short_description": "Part of an amusement park chain with roller coasters, rides, live shows, a water park, food & beer.",
      "poi_long_description": "Part of an amusement park chain with roller coasters, rides, live shows, a water park, food & beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-a86f-770d-a5a1-ca976bb72d92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-a86f-770d-a5a1-ca976bb72d92",
        "storage_key": "property/5738013569056768/019f14f2-a86f-770d-a5a1-ca976bb72d92.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sixflags.com/fiestatexas?utm_source=googlebusinessprofile&utm_medium=organic&utm_campaign=Google+Business+Profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=2548967654066146973&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "six-flags-fiesta-texas",
      "poi_latitude": "29.5993818",
      "poi_longitude": "-98.6088838",
      "poi_miles_from_property": "17.0 mi",
      "poi_walking_minutes": "6 hours 23 mins",
      "poi_biking_minutes": "1 hour 44 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 210-697-5050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e430-76fa-8c15-776feffd3990",
        "storage_key": "property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN55XmxZlXIYRnc6SjJPAXyM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_0caf2979e221e060eff231fb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "The DoSeum",
      "poi_type": "Entertainment",
      "poi_address": "2800 Broadway, San Antonio, TX 78209, USA",
      "poi_short_description": "2-story museum promoting learning & discovery through interactive exhibits & creative programs.",
      "poi_long_description": "2-story museum promoting learning & discovery through interactive exhibits & creative programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-a489-710e-8d8e-a140cf5660fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-a489-710e-8d8e-a140cf5660fb",
        "storage_key": "property/5738013569056768/019f14f2-a489-710e-8d8e-a140cf5660fb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://thedoseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15763963794875614826&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-doseum",
      "poi_latitude": "29.4533152",
      "poi_longitude": "-98.4716971",
      "poi_miles_from_property": "13.5 mi",
      "poi_walking_minutes": "5 hours 3 mins",
      "poi_biking_minutes": "1 hour 18 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 210-212-4453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f3-02d8-732f-9d71-8b910668d30b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f3-02d8-732f-9d71-8b910668d30b",
        "storage_key": "property/5738013569056768/019f14f3-02d8-732f-9d71-8b910668d30b.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJIVWnfJL1XIYRagau5YzZxNo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_e747bbf1246f90a2512f86c4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Witte Museum",
      "poi_type": "Entertainment",
      "poi_address": "3801 Broadway, San Antonio, TX 78209, USA",
      "poi_short_description": "Touring & long-term exhibits about natural history, art & Texas heritage, plus a Science Treehouse.",
      "poi_long_description": "Touring & long-term exhibits about natural history, art & Texas heritage, plus a Science Treehouse.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-b209-72ca-94bd-36ca0c028379.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-b209-72ca-94bd-36ca0c028379",
        "storage_key": "property/5738013569056768/019f14f2-b209-72ca-94bd-36ca0c028379.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.wittemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14696973662473378755&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "witte-museum",
      "poi_latitude": "29.46197799999999",
      "poi_longitude": "-98.4669496",
      "poi_miles_from_property": "14.2 mi",
      "poi_walking_minutes": "5 hours 18 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 210-357-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f3-02d8-732f-9d71-8b910668d30b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f3-02d8-732f-9d71-8b910668d30b",
        "storage_key": "property/5738013569056768/019f14f3-02d8-732f-9d71-8b910668d30b.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8SkZWZf1XIYRw1v_mK0j9ss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_299a7bcca374351c12cac3e0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "The Shops at La Cantera",
      "poi_type": "Entertainment",
      "poi_address": "15900 La Cantera Pkwy Ste 6698, San Antonio, TX 78256, USA",
      "poi_short_description": "Upscale shopping center along an outdoor mall-style walkway with a wide variety of restaurants, shops and food options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-aad0-7289-b270-c9b6e760fd97.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-aad0-7289-b270-c9b6e760fd97",
        "storage_key": "property/5738013569056768/019f14f2-aad0-7289-b270-c9b6e760fd97.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.theshopsatlacantera.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=11016393100736632124&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-shops-at-la-cantera",
      "poi_latitude": "29.5922066",
      "poi_longitude": "-98.6153483",
      "poi_miles_from_property": "15.4 mi",
      "poi_walking_minutes": "5 hours 46 mins",
      "poi_biking_minutes": "1 hour 33 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 210-582-6255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e471-7301-a811-0f4a60237eff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e471-7301-a811-0f4a60237eff",
        "storage_key": "property/5738013569056768/019f14f0-e471-7301-a811-0f4a60237eff.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ4RQtcodmXIYRPJV4YygX4pg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_51921ab8fcc77dd7da04b602",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Alamo Quarry Market",
      "poi_type": "Entertainment",
      "poi_address": "255 E Basse Rd, San Antonio, TX 78209, USA",
      "poi_short_description": "Airy mall home to major apparel & homewares stores, eclectic eateries & a cinema amid a modern site.",
      "poi_long_description": "Airy mall home to major apparel & homewares stores, eclectic eateries & a cinema amid a modern site.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-ab87-73a9-9aec-a7a5e59ff132.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-ab87-73a9-9aec-a7a5e59ff132",
        "storage_key": "property/5738013569056768/019f14f2-ab87-73a9-9aec-a7a5e59ff132.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://quarrymarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4663225067816664189&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alamo-quarry-market",
      "poi_latitude": "29.4962615",
      "poi_longitude": "-98.4799046",
      "poi_miles_from_property": "16.1 mi",
      "poi_walking_minutes": "6 hours 2 mins",
      "poi_biking_minutes": "1 hour 23 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 210-824-8885",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e471-7301-a811-0f4a60237eff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e471-7301-a811-0f4a60237eff",
        "storage_key": "property/5738013569056768/019f14f0-e471-7301-a811-0f4a60237eff.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ7See-2D1XIYRfbzoCn4at0A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_9ce6da6117eb68a5531ba2ec",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Alamo City Urgent Care | Marbach",
      "poi_type": "Health and Wellness",
      "poi_address": "8223 Marbach Rd Ste 102, San Antonio, TX 78227, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-aba1-737e-b57b-74cef9941d9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-aba1-737e-b57b-74cef9941d9f",
        "storage_key": "property/5738013569056768/019f14f2-aba1-737e-b57b-74cef9941d9f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.alamocityuc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4362317219798385682&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alamo-city-urgent-care--marbach",
      "poi_latitude": "29.4192607",
      "poi_longitude": "-98.6535624",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 210-941-2282",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e430-76fa-8c15-776feffd3990",
        "storage_key": "property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa5i_8ZtdXIYREgSnG2YQijw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_511f4f19beb7da2997bc2288",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Trinity Specialty Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "7323 Marbach Rd #105, San Antonio, TX 78227, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://alamospecialtyrx.com/trinity-pharmacy/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5791638499116918959&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trinity-specialty-pharmacy",
      "poi_latitude": "29.4182714",
      "poi_longitude": "-98.6348913",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-233-6054",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f3-02d2-762e-9f4f-60934b8224ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f3-02d2-762e-9f4f-60934b8224ec",
        "storage_key": "property/5738013569056768/019f14f3-02d2-762e-9f4f-60934b8224ec.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzbVb4RZdXIYRryhXj4cIYFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_475cd81843096c90e907ef77",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "7103 Marbach Rd, San Antonio, TX 78227, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-80a5-72ec-a94f-4e25e0e4825d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-80a5-72ec-a94f-4e25e0e4825d",
        "storage_key": "property/5738013569056768/019f14f2-80a5-72ec-a94f-4e25e0e4825d.webp",
        "width": 1280,
        "height": 554
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-7103+marbach+rd-san+antonio-tx-78227/id=3563",
      "poi_directions_map_url": "https://maps.google.com/?cid=15506384911370783225&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "29.4181295",
      "poi_longitude": "-98.6300986",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-675-6612",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e430-76fa-8c15-776feffd3990",
        "storage_key": "property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCQAcpJ1cXIYR-Ym7qOu-Mdc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_df61c2b8c389ec365ec904da",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "H-E-B plus!",
      "poi_type": "Health and Wellness",
      "poi_address": "8219 Marbach Rd, San Antonio, TX 78227, USA",
      "poi_short_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_long_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-21f7-75dc-a600-c3ea71088863.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-21f7-75dc-a600-c3ea71088863",
        "storage_key": "property/5738013569056768/019f14f0-21f7-75dc-a600-c3ea71088863.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/san-antonio/marbach-and-410-h-e-b-plus--613?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=2452901904169700394&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b-plus",
      "poi_latitude": "29.4199914",
      "poi_longitude": "-98.6526562",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-673-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e42f-7488-ab85-3e68e32faf90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e42f-7488-ab85-3e68e32faf90",
        "storage_key": "property/5738013569056768/019f14f0-e42f-7488-ab85-3e68e32faf90.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUeFtCKlcXIYRKgzqKkl1CiI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_9f287bda8e2f83481dc136ab",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "7239 SW Loop 410, San Antonio, TX 78242, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-aa67-7630-a9a9-b023e9a6f929.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-aa67-7630-a9a9-b023e9a6f929",
        "storage_key": "property/5738013569056768/019f14f2-aa67-7630-a9a9-b023e9a6f929.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/999-san-antonio-tx/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=3437707627394233509&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "29.3593726",
      "poi_longitude": "-98.6345777",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 210-247-5912",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f3-02d2-762e-9f4f-60934b8224ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f3-02d2-762e-9f4f-60934b8224ec",
        "storage_key": "property/5738013569056768/019f14f3-02d2-762e-9f4f-60934b8224ec.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbfVhL-ZaXIYRpfR7lN8wtS8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_d59d8d81ae659e8948401788",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Crunch Fitness - San Antonio Westlakes",
      "poi_type": "Health and Wellness",
      "poi_address": "1339 SW Loop 410, San Antonio, TX 78227, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-b74c-745e-9a82-5d0d4a0aacbf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-b74c-745e-9a82-5d0d4a0aacbf",
        "storage_key": "property/5738013569056768/019f14f2-b74c-745e-9a82-5d0d4a0aacbf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.crunch.com/locations/sa-westlakes",
      "poi_directions_map_url": "https://maps.google.com/?cid=2024824440938065062&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crunch-fitness---san-antonio-westlakes",
      "poi_latitude": "29.4221507",
      "poi_longitude": "-98.6507639",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-338-1381",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e430-76fa-8c15-776feffd3990",
        "storage_key": "property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrWq_ERNdXIYRpmyk3hmfGRw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_4807a7b81f6aad530dc9dcfa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Los Campeones Gym San Antonio",
      "poi_type": "Health and Wellness",
      "poi_address": "8715 Marbach Rd, San Antonio, TX 78227, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-bb84-7275-bf43-9d5873dbbc15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-bb84-7275-bf43-9d5873dbbc15",
        "storage_key": "property/5738013569056768/019f14f2-bb84-7275-bf43-9d5873dbbc15.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://loscampeonesmarbach.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6065753724754376833&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "los-campeones-gym-san-antonio",
      "poi_latitude": "29.4193954",
      "poi_longitude": "-98.6568145",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 210-277-0082",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e430-76fa-8c15-776feffd3990",
        "storage_key": "property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFY3Ra35dXIYRgbj8-t_iLVQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_0588573d1e87fbb1c6e8d6a9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1739 SW Loop 410 Ste 814, San Antonio, TX 78227, USA",
      "poi_short_description": "Chain fitness center offering a variety of equipment, plus tanning, and massage services.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-4f5b-704e-a95c-83c4704d8290.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-4f5b-704e-a95c-83c4704d8290",
        "storage_key": "property/5738013569056768/019f14f0-4f5b-704e-a95c-83c4704d8290.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/san-antonio-marbach-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=3375805685990406688&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "29.4161669",
      "poi_longitude": "-98.6514516",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-592-8727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e430-76fa-8c15-776feffd3990",
        "storage_key": "property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ6lp11dbXIYRILozuGJF2S4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_695b89e8903f912fb05aa0e8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "9686 Marbach Rd, San Antonio, TX 78245, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-bcc3-775d-9e63-49e268415f57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-bcc3-775d-9e63-49e268415f57",
        "storage_key": "property/5738013569056768/019f14f2-bcc3-775d-9e63-49e268415f57.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/san-antonio-tx-pharmacies/9686-marbach-rd-san-antonio-tx-78245/storeid=10347?WT.mc_id=LS_GOOGLE_RX_10347",
      "poi_directions_map_url": "https://maps.google.com/?cid=15029764550215940267&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "29.4170941",
      "poi_longitude": "-98.6776793",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-645-6933",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f3-02d2-762e-9f4f-60934b8224ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f3-02d2-762e-9f4f-60934b8224ec",
        "storage_key": "property/5738013569056768/019f14f3-02d2-762e-9f4f-60934b8224ec.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD3abw15DXIYRqzhhMTpzlNA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_9a923250a4ea5d14f72fddb5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Tom Slick Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7400 Texas 151 Access Rd, San Antonio, TX 78227, USA",
      "poi_short_description": "Suburban park with a 1-acre dog area, pond & baseball, football & soccer fields & pavilion for hire.",
      "poi_long_description": "Suburban park with a 1-acre dog area, pond & baseball, football & soccer fields & pavilion for hire.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-c748-764c-a574-2ab0796c1e3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-c748-764c-a574-2ab0796c1e3d",
        "storage_key": "property/5738013569056768/019f14f2-c748-764c-a574-2ab0796c1e3d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.sanantonio.gov/ParksAndRec/Parks-Facilities/All-Parks-Facilities/Parks-Facilities-Details/ArtMID/14820/ArticleID/2493/Slick-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=4013846829374659664&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tom-slick-park",
      "poi_latitude": "29.4304963",
      "poi_longitude": "-98.6347818",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-207-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e531-7716-83be-9d37d6147b7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e531-7716-83be-9d37d6147b7c",
        "storage_key": "property/5738013569056768/019f14f0-e531-7716-83be-9d37d6147b7c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJETeE8pZcXIYRUFy0z2wMtDc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_dc2886041969d74c1d47f5f1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Medina Base Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6303 Medina Base Rd, San Antonio, TX 78242, USA",
      "poi_short_description": "Relaxed, tree-filled play space with barbecue grills, a basketball court and a paved trail.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-ca5c-75a8-b355-11422275df2c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-ca5c-75a8-b355-11422275df2c",
        "storage_key": "property/5738013569056768/019f14f2-ca5c-75a8-b355-11422275df2c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sa.gov/Directory/Departments/Parks/Parks-Facilities/Parks/Directory/Medina-Base-Road-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=11323803790026697204&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "medina-base-park",
      "poi_latitude": "29.3683587",
      "poi_longitude": "-98.6310965",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-207-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e531-7716-83be-9d37d6147b7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e531-7716-83be-9d37d6147b7c",
        "storage_key": "property/5738013569056768/019f14f0-e531-7716-83be-9d37d6147b7c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2bU_QeJaXIYR9GnDCo07Jp0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_6e4b364b609f16c14f0df9a5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Levi Strauss Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6100 Old Hwy 90 W, San Antonio, TX 78227, USA",
      "poi_short_description": "Clean city park featuring a playground, basketball courts, soccer fields, a walking path and BBQ grills.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-c43f-71c9-8550-b23c9afdcad7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-c43f-71c9-8550-b23c9afdcad7",
        "storage_key": "property/5738013569056768/019f14f2-c43f-71c9-8550-b23c9afdcad7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.sa.gov/Directory/Departments/Parks/Parks-Facilities/Parks/Directory/Levi-Strauss-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=17063293791435567053&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "levi-strauss-park",
      "poi_latitude": "29.4106843",
      "poi_longitude": "-98.6063616",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 210-207-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e531-7716-83be-9d37d6147b7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e531-7716-83be-9d37d6147b7c",
        "storage_key": "property/5738013569056768/019f14f0-e531-7716-83be-9d37d6147b7c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJvy2i5YVbXIYRzS-lUEz_zOw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_254ef18eb60e26555a35620f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Arvil Ave Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Leon Creek Greenway, San Antonio, TX 78227, USA",
      "poi_short_description": "Park featuring a concrete walkway, plus swings, slides and picnic tables.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-c8f7-7210-ad09-2064245643e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-c8f7-7210-ad09-2064245643e1",
        "storage_key": "property/5738013569056768/019f14f2-c8f7-7210-ad09-2064245643e1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.sanantonio.gov/ParksAndRec/Home",
      "poi_directions_map_url": "https://maps.google.com/?cid=3166807431216708867&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arvil-ave-trailhead",
      "poi_latitude": "29.4123086",
      "poi_longitude": "-98.6149224",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 210-207-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e430-76fa-8c15-776feffd3990",
        "storage_key": "property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRTmO7YFbXIYRAz29iZTC8is",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "ec_55479ad6f720e9ac2a1f8fab",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Rodriguez Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2060 Rodriguez Ave, San Antonio, TX 78227, USA",
      "poi_short_description": "Picnickers frequent this city park, which offers a ball field, a playground, trails & BBQ grills.",
      "poi_long_description": "Picnickers frequent this city park, which offers a ball field, a playground, trails & BBQ grills.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-d107-746d-bb57-2cf718b2a39b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-d107-746d-bb57-2cf718b2a39b",
        "storage_key": "property/5738013569056768/019f14f2-d107-746d-bb57-2cf718b2a39b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bexar.org/1240/County-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=15606393025446105000&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rodriguez-park",
      "poi_latitude": "29.412416",
      "poi_longitude": "-98.6143975",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 210-335-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e531-7716-83be-9d37d6147b7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e531-7716-83be-9d37d6147b7c",
        "storage_key": "property/5738013569056768/019f14f0-e531-7716-83be-9d37d6147b7c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8W_7xIZbXIYRqE_ZOsULldg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_199842d503d7061cd2a96e2b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Lackland Terrace Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7902 Westshire Dr, San Antonio, TX 78227, USA",
      "poi_short_description": "Well-kept park featuring a walking trail, basketball court, along with a playground.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-c4fa-70a7-9137-086de917e048.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-c4fa-70a7-9137-086de917e048",
        "storage_key": "property/5738013569056768/019f14f2-c4fa-70a7-9137-086de917e048.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sanantonio.gov/ParksAndRec/ParksFacilities/AllParksFacilities/ParksFacilitiesDetails/TabId/3354/ArtMID/14820/ArticleID/2608/Lackland-Terrace-Park-.aspx?Park=118",
      "poi_directions_map_url": "https://maps.google.com/?cid=17035457857518048922&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lackland-terrace-park",
      "poi_latitude": "29.4114725",
      "poi_longitude": "-98.6439605",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-207-8480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e531-7716-83be-9d37d6147b7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e531-7716-83be-9d37d6147b7c",
        "storage_key": "property/5738013569056768/019f14f0-e531-7716-83be-9d37d6147b7c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJed-Ut15bXIYRmhaA56kaauw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_e2c4bd760893932453340035",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Lackland Corridor Gateway Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6534 Military Dr W, San Antonio, TX 78227, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-d230-7791-97f4-d0f9b715e928.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-d230-7791-97f4-d0f9b715e928",
        "storage_key": "property/5738013569056768/019f14f2-d230-7791-97f4-d0f9b715e928.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.sanantonio.gov/TCI/Projects/Lackland-Corridor-Gateway-Project#228111583-about-the-project",
      "poi_directions_map_url": "https://maps.google.com/?cid=3301921421410968907&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lackland-corridor-gateway-park",
      "poi_latitude": "29.4013534",
      "poi_longitude": "-98.6265407",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 210-207-8022",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e531-7716-83be-9d37d6147b7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e531-7716-83be-9d37d6147b7c",
        "storage_key": "property/5738013569056768/019f14f0-e531-7716-83be-9d37d6147b7c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJFci-u0NbXIYRSyV01wnI0i0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_5f7ccb3a3451553263c16351",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Meadowcliff Community Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1260 Pinn Rd, San Antonio, TX 78227, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-d10d-713b-a350-1123c5b657f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-d10d-713b-a350-1123c5b657f3",
        "storage_key": "property/5738013569056768/019f14f2-d10d-713b-a350-1123c5b657f3.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.sanantonio.gov/ParksAndRec/Parks-Facilities/All-Parks-Facilities/Facility-Details/ArtMID/16234/ArticleID/2864/Meadowcliff-Community-Center?Park=&Facility=34",
      "poi_directions_map_url": "https://maps.google.com/?cid=4282341635919889818&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meadowcliff-community-center",
      "poi_latitude": "29.4230739",
      "poi_longitude": "-98.623068",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-674-0820",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e430-76fa-8c15-776feffd3990",
        "storage_key": "property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6y-ocoRcXIYRmsXebwfvbTs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "ec_b8ffbf6e6359718823b71520",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Pearsall Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4838 Old Pearsall Rd, San Antonio, TX 78242, USA",
      "poi_short_description": "Large recreation area with a disc golf course, playground, skate park, splash pads & outdoor gym.",
      "poi_long_description": "Large recreation area with a disc golf course, playground, skate park, splash pads & outdoor gym.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-846b-77b4-b40b-6b8752eda5b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-846b-77b4-b40b-6b8752eda5b1",
        "storage_key": "property/5738013569056768/019f14f0-846b-77b4-b40b-6b8752eda5b1.webp",
        "width": 1280,
        "height": 932
      },
      "poi_business_url": "https://www.sanantonio.gov/ParksAndRec/Parks-Facilities/All-Parks-Facilities/Parks-Facilities-Details/ArtMID/14820/ArticleID/2528/Pearsall-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=10199585792094813157&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pearsall-park",
      "poi_latitude": "29.3591092",
      "poi_longitude": "-98.5952889",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 210-207-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e531-7716-83be-9d37d6147b7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e531-7716-83be-9d37d6147b7c",
        "storage_key": "property/5738013569056768/019f14f0-e531-7716-83be-9d37d6147b7c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ11JedTdaXIYR5bvu-Tw1jI0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_bfacbc39c32b560d0848b667",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Jim Mattox Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1222 Mission Grande, San Antonio, TX 78221, USA",
      "poi_short_description": "Park offering a playground, a public restroom, and facilities for golfing.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-dbfa-7451-b383-3f2039e05265.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-dbfa-7451-b383-3f2039e05265",
        "storage_key": "property/5738013569056768/019f14f2-dbfa-7451-b383-3f2039e05265.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sa.gov/Directory/Departments/Parks/Parks-Facilities/Parks/Directory/Mattox-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=558451012257020442&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jim-mattox-park",
      "poi_latitude": "29.2936367",
      "poi_longitude": "-98.4766029",
      "poi_miles_from_property": "18.4 mi",
      "poi_walking_minutes": "6 hours 47 mins",
      "poi_biking_minutes": "1 hour 56 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 210-207-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e531-7716-83be-9d37d6147b7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e531-7716-83be-9d37d6147b7c",
        "storage_key": "property/5738013569056768/019f14f0-e531-7716-83be-9d37d6147b7c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJfRan9Hv4XIYRGnoJojwEwAc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_be176203e9c15bbd8b4d4d45",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Marbach & Loop 410 S Access Rd.",
      "poi_type": "Transportation & Transit",
      "poi_address": "San Antonio, TX 78227, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-df8d-71c9-9f97-9372c9383a3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-df8d-71c9-9f97-9372c9383a3d",
        "storage_key": "property/5738013569056768/019f14f2-df8d-71c9-9f97-9372c9383a3d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13762765676639431163&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marbach--loop-410-s-access-rd",
      "poi_latitude": "29.417807",
      "poi_longitude": "-98.650792",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e430-76fa-8c15-776feffd3990",
        "storage_key": "property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI2qyWKhcXIYR-ykI83Yq_74",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_3b4575a739c8ff8697941763",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Horal & Marbach (300 Ft. North)",
      "poi_type": "Transportation & Transit",
      "poi_address": "San Antonio, TX 78245, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10483368076369921309&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "horal--marbach-300-ft-north",
      "poi_latitude": "29.419105",
      "poi_longitude": "-98.6551183",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e430-76fa-8c15-776feffd3990",
        "storage_key": "property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_2wM56tcXIYRHQWz4bhnfJE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_ba94548907aad5306c4b34d3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Marbach In Front Of 7624",
      "poi_type": "Transportation & Transit",
      "poi_address": "San Antonio, TX 78227, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9961564384123800412&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marbach-in-front-of-7624",
      "poi_latitude": "29.4177",
      "poi_longitude": "-98.63978",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e430-76fa-8c15-776feffd3990",
        "storage_key": "property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvRvWRaBcXIYRXMvhWgeWPoo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_b75f3c4e1a074b2dd7dbab43",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Potranco & Tisbury Pkwy",
      "poi_type": "Transportation & Transit",
      "poi_address": "San Antonio, TX 78251, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-e301-764f-805e-20b786a2287a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-e301-764f-805e-20b786a2287a",
        "storage_key": "property/5738013569056768/019f14f2-e301-764f-805e-20b786a2287a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10760892870041201471&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "potranco--tisbury-pkwy",
      "poi_latitude": "29.440112",
      "poi_longitude": "-98.672655",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e430-76fa-8c15-776feffd3990",
        "storage_key": "property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxZRttzlDXIYRP-vWOA1fVpU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_2b3c814afff32750adbaf48c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Sw Loop 410 S Access Rd At 1749",
      "poi_type": "Transportation & Transit",
      "poi_address": "San Antonio, TX 78227, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9718446202524633359&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sw-loop-410-s-access-rd-at-1749",
      "poi_latitude": "29.4153515",
      "poi_longitude": "-98.6500746",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e430-76fa-8c15-776feffd3990",
        "storage_key": "property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXSPlG6hcXIYRD4k5plTb3oY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_964f1125be94a4adf90491d2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "VIA Crossroads Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "151 N Crossroads Blvd, Balcones Heights, TX 78201, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-efff-74ba-a911-fed9671ff674.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-efff-74ba-a911-fed9671ff674",
        "storage_key": "property/5738013569056768/019f14f2-efff-74ba-a911-fed9671ff674.webp",
        "width": 1280,
        "height": 577
      },
      "poi_business_url": "http://viainfo.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14912817806174523366&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "via-crossroads-park--ride",
      "poi_latitude": "29.493575",
      "poi_longitude": "-98.5483679",
      "poi_miles_from_property": "10.8 mi",
      "poi_walking_minutes": "4 hours 5 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 210-362-2892",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f3-02da-76f3-91f7-e272a1484e27.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f3-02da-76f3-91f7-e272a1484e27",
        "storage_key": "property/5738013569056768/019f14f3-02da-76f3-91f7-e272a1484e27.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJNXQTzYRfXIYR5g8ngcj49M4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_c43a720aa562ec9fda453d1a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Greyhound Shop",
      "poi_type": "Transportation & Transit",
      "poi_address": "500 N St Mary's St, San Antonio, TX 78205, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-e7ca-75aa-a608-acb6a3e9be31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-e7ca-75aa-a608-acb6a3e9be31",
        "storage_key": "property/5738013569056768/019f14f2-e7ca-75aa-a608-acb6a3e9be31.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.greyhound.com/bus/san-antonio-tx/san-antonio-bus-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=2193265979862775306&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-shop",
      "poi_latitude": "29.4289054",
      "poi_longitude": "-98.4911807",
      "poi_miles_from_property": "11.3 mi",
      "poi_walking_minutes": "4 hours 13 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 800-231-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e430-76fa-8c15-776feffd3990",
        "storage_key": "property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi7PjnzWWXIYRCnary8kLcB4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_f3cbf9c08b8743dfcada8e88",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "San Antonio",
      "poi_type": "Transportation & Transit",
      "poi_address": "350 Hoefgen Ave, San Antonio, TX 78205, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-f04c-76f8-94fa-436203806813.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-f04c-76f8-94fa-436203806813",
        "storage_key": "property/5738013569056768/019f14f2-f04c-76f8-94fa-436203806813.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=SAS",
      "poi_directions_map_url": "https://maps.google.com/?cid=252101692702324059&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-antonio",
      "poi_latitude": "29.4193442",
      "poi_longitude": "-98.4780353",
      "poi_miles_from_property": "12.1 mi",
      "poi_walking_minutes": "4 hours 32 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f3-0303-7192-a638-435acd6c87ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f3-0303-7192-a638-435acd6c87ee",
        "storage_key": "property/5738013569056768/019f14f3-0303-7192-a638-435acd6c87ee.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJm_yTrQb2XIYRW_XLYCelfwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_d291c3906424f69f4637cb3e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "San Antonio International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "9800 Airport Blvd, San Antonio, TX 78216, USA",
      "poi_short_description": "Airport offering international flights plus eateries & car-rental options.",
      "poi_long_description": "Airport offering international flights plus eateries & car-rental options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-e3de-76fb-8be9-aac166bbf78c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-e3de-76fb-8be9-aac166bbf78c",
        "storage_key": "property/5738013569056768/019f14f2-e3de-76fb-8be9-aac166bbf78c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.flysanantonio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18041828760938859602&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-antonio-international-airport",
      "poi_latitude": "29.5331282",
      "poi_longitude": "-98.4705422",
      "poi_miles_from_property": "19.6 mi",
      "poi_walking_minutes": "7 hours 20 mins",
      "poi_biking_minutes": "2 hours 20 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 210-207-3433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f3-0303-7192-a638-47eb2fe53d50.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f3-0303-7192-a638-47eb2fe53d50",
        "storage_key": "property/5738013569056768/019f14f3-0303-7192-a638-47eb2fe53d50.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ4DLsbuKXIYRUswvGqtzYfo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_5a68f77dcc6151b25eb17422",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Lackland Air Force Base",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Lackland Air Force Base, TX 78236, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-ea67-725e-8951-ced6498134f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-ea67-725e-8951-ced6498134f7",
        "storage_key": "property/5738013569056768/019f14f2-ea67-725e-8951-ced6498134f7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14899195159459004593&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lackland-air-force-base",
      "poi_latitude": "29.3862076",
      "poi_longitude": "-98.6179099",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 210-671-1110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e531-7716-83be-a1c312b863a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e531-7716-83be-a1c312b863a9",
        "storage_key": "property/5738013569056768/019f14f0-e531-7716-83be-a1c312b863a9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNZ5uPVlbXIYRsQDG5g6TxM4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_f94cc9d022b861f680978ebd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Northwest Vista College",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3535 N Ellison Dr, San Antonio, TX 78251, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-2c24-74e8-ab4b-db0b6fc3e7a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-2c24-74e8-ab4b-db0b6fc3e7a7",
        "storage_key": "property/5738013569056768/019f14f0-2c24-74e8-ab4b-db0b6fc3e7a7.webp",
        "width": 1137,
        "height": 640
      },
      "poi_business_url": "https://www.alamo.edu/nvc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17417931226689792052&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northwest-vista-college",
      "poi_latitude": "29.4716439",
      "poi_longitude": "-98.705443",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 210-486-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e418-7223-b703-6a65118c5bb2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e418-7223-b703-6a65118c5bb2",
        "storage_key": "property/5738013569056768/019f14f0-e418-7223-b703-6a65118c5bb2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJO8IBBVpCXIYRNGgHoSrsuPE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_65016779b8c8473ad9d8bca3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Boeing Center at Tech Port",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3331 General Hudnell Dr, San Antonio, TX 78226, USA",
      "poi_short_description": "State-of-the-art complex featuring a 3,200-seat concert arena, a LAN gaming center, and a museum.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-ef88-74f2-a6ee-77e267e34726.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-ef88-74f2-a6ee-77e267e34726",
        "storage_key": "property/5738013569056768/019f14f2-ef88-74f2-a6ee-77e267e34726.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://boeingcentertechport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18240060577714093708&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boeing-center-at-tech-port",
      "poi_latitude": "29.3813734",
      "poi_longitude": "-98.5651695",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 210-600-3699",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e430-76fa-8c15-776feffd3990",
        "storage_key": "property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOy6Uh_tZXIYRjD5BmHS2If0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "ec_afee110557429aab6d8597c0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "St. Mary's University",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Camino Santa Maria, San Antonio, TX 78228, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-30c1-712f-b811-669a9f2bcf6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-30c1-712f-b811-669a9f2bcf6c",
        "storage_key": "property/5738013569056768/019f14f0-30c1-712f-b811-669a9f2bcf6c.webp",
        "width": 1100,
        "height": 734
      },
      "poi_business_url": "https://www.stmarytx.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4585771025216223167&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-marys-university",
      "poi_latitude": "29.4522978",
      "poi_longitude": "-98.5646836",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 210-436-3011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e418-7223-b703-6a65118c5bb2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e418-7223-b703-6a65118c5bb2",
        "storage_key": "property/5738013569056768/019f14f0-e418-7223-b703-6a65118c5bb2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ80njWJdeXIYRv7dKc3Puoz8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_626a4e9a172e4c0c2d61ae19",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "University Health University Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4502 Medical Dr, San Antonio, TX 78229, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-e9b3-71d5-8cca-918e2dd867a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-e9b3-71d5-8cca-918e2dd867a6",
        "storage_key": "property/5738013569056768/019f14f2-e9b3-71d5-8cca-918e2dd867a6.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.universityhealth.com/locations/university-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=3269778978862236901&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-health-university-hospital",
      "poi_latitude": "29.5078888",
      "poi_longitude": "-98.5775051",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 40 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 210-358-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e4f6-74de-8057-0e0581bcdf84.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e4f6-74de-8057-0e0581bcdf84",
        "storage_key": "property/5738013569056768/019f14f0-e4f6-74de-8057-0e0581bcdf84.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJVSW2JPldXIYR5YQfQaiWYC0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_f4c7d7528dbdb0fca453ed95",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Methodist Hospital - Westover Hills",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5106 W Loop 1604 N, San Antonio, TX 78251, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-ed88-72ba-b80c-168b20b0c812.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-ed88-72ba-b80c-168b20b0c812",
        "storage_key": "property/5738013569056768/019f14f2-ed88-72ba-b80c-168b20b0c812.webp",
        "width": 1147,
        "height": 767
      },
      "poi_business_url": "https://www.sahealth.com/westoverhills?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=13823487835345657809&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "methodist-hospital---westover-hills",
      "poi_latitude": "29.4842968",
      "poi_longitude": "-98.7047654",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 726-243-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e4f6-74de-8057-0e0581bcdf84.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e4f6-74de-8057-0e0581bcdf84",
        "storage_key": "property/5738013569056768/019f14f0-e4f6-74de-8057-0e0581bcdf84.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJOaHoDQBDXIYR0R-2PvLk1r8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_1bff3f3cec118e7fb588cfec",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "The University of Texas at San Antonio",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Physical Education Building, 1 UTSA Circle, San Antonio, TX 78249, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-f456-7098-b2bc-27403e95c3aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-f456-7098-b2bc-27403e95c3aa",
        "storage_key": "property/5738013569056768/019f14f2-f456-7098-b2bc-27403e95c3aa.webp",
        "width": 1280,
        "height": 834
      },
      "poi_business_url": "https://www.utsa.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2658632929587635980&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-university-of-texas-at-san-antonio",
      "poi_latitude": "29.5830733",
      "poi_longitude": "-98.6198779",
      "poi_miles_from_property": "14.8 mi",
      "poi_walking_minutes": "5 hours 34 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 210-458-4011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e418-7223-b703-6a65118c5bb2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e418-7223-b703-6a65118c5bb2",
        "storage_key": "property/5738013569056768/019f14f0-e418-7223-b703-6a65118c5bb2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3X9l1n1mXIYRDCc6PJBc5SQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_66a67f4825aa9a32dfb8083b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "USAA Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9800 Fredericksburg Rd, San Antonio, TX 78288, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-f757-70ec-8a98-4f72514e20bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-f757-70ec-8a98-4f72514e20bc",
        "storage_key": "property/5738013569056768/019f14f2-f757-70ec-8a98-4f72514e20bc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.usaa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7341051404387659836&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "usaa-corporate-office",
      "poi_latitude": "29.5371902",
      "poi_longitude": "-98.5752478",
      "poi_miles_from_property": "11.6 mi",
      "poi_walking_minutes": "4 hours 25 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 800-531-8722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e430-76fa-8c15-776feffd3990",
        "storage_key": "property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyyb6ITJnXIYRPLBolFun4GU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_92a9683b5afa9cd5120ec1c6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Valero",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Valero Way, San Antonio, TX 78249, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-fdf8-74da-b474-48a97ab3caa5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-fdf8-74da-b474-48a97ab3caa5",
        "storage_key": "property/5738013569056768/019f14f2-fdf8-74da-b474-48a97ab3caa5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.valero.com/ourbusiness/ourlocations/offices/pages/valerocorporateheadquarters.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=16201185604516536043&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valero",
      "poi_latitude": "29.5869869",
      "poi_longitude": "-98.6070957",
      "poi_miles_from_property": "15.4 mi",
      "poi_walking_minutes": "5 hours 45 mins",
      "poi_biking_minutes": "1 hour 23 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 210-345-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e430-76fa-8c15-776feffd3990",
        "storage_key": "property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv1eqHI5mXIYR615hQXgs1uA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_af3d5ce67e6752d09e26a3cc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "generator",
      "poi_name": "Southwest Research Institute",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6220 Culebra Rd, San Antonio, TX 78238, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f2-f895-74e6-bbb8-8c8d4595ce76.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f2-f895-74e6-bbb8-8c8d4595ce76",
        "storage_key": "property/5738013569056768/019f14f2-f895-74e6-bbb8-8c8d4595ce76.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.swri.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=181758218444497686&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southwest-research-institute",
      "poi_latitude": "29.4521256",
      "poi_longitude": "-98.6102811",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-684-5111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e430-76fa-8c15-776feffd3990",
        "storage_key": "property/5738013569056768/019f14f0-e430-76fa-8c15-776feffd3990.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_8dKB1pcXIYRFmNk_SK8hQI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    }
  ],
  "office_hours": [
    {
      "id": "custom_1da660ce-b97d-409f-9696-c39849d92bc4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_133dabe8-d183-4b16-9908-1838a29d3900",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_221d63af-da1a-42f2-b3d3-086c4121ea52",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_7dbd70c5-50fb-451f-97da-9483a8b155cd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_42a95f14-b163-48be-8e41-576b3b937305",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "19:00"
    },
    {
      "id": "custom_56b9dbc1-c469-4eb7-80a5-a4ccb660a868",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "19:00"
    },
    {
      "id": "custom_e9ebe88f-c9bc-47df-b048-0ffe1e8f9901",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "day": "SUN",
      "open_time": "13:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_95f4c42a944dfeda5ad0d32f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "rating": "5",
      "name": "Victor Ogunmola",
      "text": "The management,office staffs,technicians of this apartments are very good,always listening to the tenants complaints and taking immediate action, I highly recommended for those that looking for good and well organized environment. The apartments managers and staffs are topnotch.",
      "date": "2026-05-22",
      "title": "false"
    },
    {
      "id": "ec_250f85f08eae9af06469cbde",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "rating": "5",
      "name": "CARMELO ROCHE",
      "text": "I’ve had a great experience living at The Legend Apartments. The property is very well maintained, and the apartments themselves are beautiful and comfortable. One thing that really stands out is how quickly the maintenance team responds whenever an issue comes up—they’re fast, professional, and always helpful.\nThe community is also very clean and pest-free, which makes it an enjoyable place to live. The front office does an excellent job communicating with residents, keeping everyone informed about community activities, payment options, and updates that support the well-being of the neighborhood.\nAs an added bonus, residents get to enjoy delicious, free Starbucks coffee, which is a nice touch and a great perk. Overall, The Legend Apartments provides a welcoming, well-managed community that truly feels like home.",
      "date": "2026-03-06",
      "title": "false"
    },
    {
      "id": "ec_d8b2af93ee513a23435078ac",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "rating": "5",
      "name": "Freedom",
      "text": "I’ve had a great experience living at The Legends! The community is well kept, peaceful, and the staff truly cares about the residents. The property manager, Kesha, goes above and beyond to make sure everything runs smoothly. She is professional, responsive, and always willing to help with any questions or concerns.\n\nIt’s clear that management takes pride in the community and works hard to keep residents happy. I definitely recommend The Legends to anyone looking for a great place to live!",
      "date": "2026-03-13",
      "title": "false"
    },
    {
      "id": "ec_99086e09c38b304b49d0822f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "rating": "5",
      "name": "TexasRobman",
      "text": "I visited for information on 2 bedroom apartments, I was welcomed in by Mervin who was super friendly and passionate about the property. He gave me a tour of the property and the 2BR which he explained were recently renovated which are very nice!\nI’ve been shopping around and Mervin was by far the friendliest agent that I’ve come across. He provided me all options and made me feel confident that this will be my next apartment which is in a few months as my plans have shifted. he’s also great at checking in and letting me know current promotions.\nMervin is an asset to this complex.\n\nThanks!\n-Robert",
      "date": "2024-02-29",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_2a5399ad-d20a-4489-ada2-73e9e4b2caa1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "2BR, 1BA - 821SF.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019d02f3-842b-750f-935d-202e27075f0a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living area and kitchen of a modern apartment with wood-look flooring and a breakfast bar.",
        "public_id": "019d02f3-842b-750f-935d-202e27075f0a",
        "storage_key": "property/5738013569056768/019d02f3-842b-750f-935d-202e27075f0a.webp",
        "width": 984,
        "height": 553
      },
      "virtual_tour_title": "2BR, 1BA - 821SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=GSu96c1Wbh5"
    },
    {
      "id": "custom_9418a6c9-5655-4377-ae5c-b3eb783bb08d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f14c3-1aad-72bf-9e12-cbdc45d8d7e0.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c3-1aad-72bf-9e12-cbdc45d8d7e0",
        "storage_key": "property/5738013569056768/019f14c3-1aad-72bf-9e12-cbdc45d8d7e0.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "The Legend Community Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/WkuHRtGhFIg?rel=0"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa46-3dd3-7568-b0a4-8ed626f38c1c",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "the-legend",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768"
    },
    {
      "lead_collector_id": "0198aa46-3e39-7389-879e-6c32ce787110",
      "lead_source": "FACEBOOK_ADS",
      "name": "the-legend",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768"
    },
    {
      "lead_collector_id": "0198aa46-3e9b-725f-820a-54598035ff6d",
      "lead_source": "LANDING_PAGE",
      "name": "the-legend",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "custom",
      "page_item_url": "the-legend-apartments-with-pool-in-san-antonio-13",
      "search_query": "apartments with pool in San Antonio",
      "category": "",
      "h1_title": "Apartments with Pool in San Antonio",
      "h2_subtitle": "Discover apartments with pool in San Antonio at The Legend. Enjoy resort-style living in TX with amenities that cater to your needs.",
      "page_copy": "Looking for luxurious apartments with a pool in San Antonio? The Legend offers just that and more. Our community features a stunning resort-style pool where you can unwind and relax under the Texas sun. Perfectly situated in the Westover Hills neighborhood, our apartments provide not just comfort, but also a vibrant community atmosphere.\n\nAt The Legend, we offer a variety of stylish one, two, and three-bedroom floor plans that cater to diverse lifestyle needs. Besides our refreshing pool, residents can enjoy other top-notch amenities like a modern fitness center, a pet play area for furry friends, and homes equipped with all essential appliances including ice makers and air conditioning. Visit us to experience this unique blend of comfort and convenience in the heart of San Antonio.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f6c12-f4f5-763a-896d-43ec1c536be3.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and island seating.",
        "public_id": "019f6c12-f4f5-763a-896d-43ec1c536be3",
        "storage_key": "property/5738013569056768/019f6c12-f4f5-763a-896d-43ec1c536be3.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "",
      "seo_description": "",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "custom",
      "page_item_url": "the-legend-pet-friendly-apartments-westover-hills-777",
      "search_query": "pet friendly apartments Westover Hills",
      "category": "",
      "h1_title": "Pet Friendly Apartments Westover Hills",
      "h2_subtitle": "Explore pet friendly apartments in Westover Hills. The Legend in San Antonio welcomes pets with our dedicated pet play area.",
      "page_copy": "Finding pet friendly apartments in Westover Hills just got easier with The Legend. Our community, nestled in this vibrant neighborhood, is a perfect match for animal lovers looking for a harmonious living experience with their pets. With our exclusive pet play area, your furry family members will have plenty of outdoor fun.\n\nThe Legend offers diverse housing options with one, two, and three-bedroom floor plans to suit different lifestyle needs. Besides being pet-friendly, our community is packed with amenities like a refreshing pool, state-of-the-art fitness center, and modern home features such as air conditioning and ice makers. Come visit us and discover why The Legend is the best place for both you and your pets in San Antonio.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f6c12-f4f5-763a-896d-43ec1c536be3.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and island seating.",
        "public_id": "019f6c12-f4f5-763a-896d-43ec1c536be3",
        "storage_key": "property/5738013569056768/019f6c12-f4f5-763a-896d-43ec1c536be3.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "",
      "seo_description": "",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "custom",
      "page_item_url": "the-legend-apartments-with-air-conditioning-bexar-county-318",
      "search_query": "apartments with air conditioning Bexar County",
      "category": "",
      "h1_title": "Apartments with Air Conditioning Bexar County",
      "h2_subtitle": "Find apartments with air conditioning in Bexar County at The Legend. Enjoy comfort and modern amenities in our vibrant San Antonio community.",
      "page_copy": "Looking for apartments with air conditioning in Bexar County? The Legend in San Antonio provides comfortable living with fully air-conditioned homes. Our stylish one, two, and three-bedroom floor plans not only ensure optimal indoor climate control but also come with a range of modern amenities designed for your convenience.\n\nNestled in the dynamic Westover Hills neighborhood, residents of The Legend enjoy access to a resort-style pool, a fully-equipped fitness center, and a dedicated pet play area. Each apartment is equipped with essential features like ranges and ice makers, ensuring a worry-free living experience. With welcoming community vibes and a prime location, The Legend is your ideal choice for comfortable living in Bexar County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f6c12-f4f5-763a-896d-43ec1c536be3.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and island seating.",
        "public_id": "019f6c12-f4f5-763a-896d-43ec1c536be3",
        "storage_key": "property/5738013569056768/019f6c12-f4f5-763a-896d-43ec1c536be3.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "",
      "seo_description": "",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "custom",
      "page_item_url": "the-legend-san-antonio-apartments-with-in-unit-laundry-589",
      "search_query": "San Antonio apartments with in-unit laundry",
      "category": "",
      "h1_title": "San Antonio Apartments with In-Unit Laundry",
      "h2_subtitle": "Explore San Antonio apartments with in-unit laundry at The Legend. Enjoy modern living with convenient amenities in TX.",
      "page_copy": "Looking for San Antonio apartments with in-unit laundry? While The Legend offers a range of conveniences, including air conditioning and high-quality appliances, our community also boasts a lineup of amenities that make laundry a breeze. Located in the bustling Westover Hills area, our apartments provide an ideal living environment where comfort meets practicality.\n\nThe Legend features stylish one, two, and three-bedroom layouts designed to accommodate diverse lifestyles. In addition to home features tailored for ease, residents benefit from a resort-style pool, fitness center, and a dedicated pet play area. Elevate your living experience in San Antonio with us, where convenience and style come together seamlessly.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f6c12-f4f5-763a-896d-43ec1c536be3.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and island seating.",
        "public_id": "019f6c12-f4f5-763a-896d-43ec1c536be3",
        "storage_key": "property/5738013569056768/019f6c12-f4f5-763a-896d-43ec1c536be3.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "",
      "seo_description": "",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "custom",
      "page_item_url": "the-legend-fitness-center-apartments-78227-110",
      "search_query": "fitness center apartments 78227",
      "category": "",
      "h1_title": "Fitness Center Apartments 78227",
      "h2_subtitle": "Discover fitness center apartments in the 78227 area at The Legend. Enjoy a healthy lifestyle with our modern amenities in San Antonio.",
      "page_copy": "If you're seeking fitness center apartments in the 78227 ZIP code, look no further than The Legend. Situated in the vibrant community of Westover Hills in San Antonio, our apartments combine luxury and practicality. With a state-of-the-art fitness center on site, you can maintain an active lifestyle just steps from your front door.\n\nAt The Legend, choose from spacious one, two, and three-bedroom floor plans, each designed with your comfort in mind. Our community is not just about fitness; enjoy a resort-style pool, a fun pet play area, and modern conveniences like air conditioning and ice makers. Experience a place where wellness and style meet effortlessly in San Antonio.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f6c12-f4f5-763a-896d-43ec1c536be3.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and island seating.",
        "public_id": "019f6c12-f4f5-763a-896d-43ec1c536be3",
        "storage_key": "property/5738013569056768/019f6c12-f4f5-763a-896d-43ec1c536be3.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "",
      "seo_description": "",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "custom",
      "page_item_url": "the-legend-1-bedroom-apartments-westover-hills-630",
      "search_query": "1 bedroom apartments westover hills san antonio",
      "category": "",
      "h1_title": "1 Bedroom Apartments Westover Hills San Antonio",
      "h2_subtitle": "Explore 1 bedroom apartments in Westover Hills, San Antonio, at The Legend. Enjoy modern amenities and a vibrant community.",
      "page_copy": "Searching for 1 bedroom apartments in Westover Hills, San Antonio? The Legend offers a perfect blend of comfort and style in this sought-after neighborhood. Each one-bedroom apartment is thoughtfully designed, providing the ideal living space with modern amenities like air conditioning and premium kitchen appliances.\n\nNestled in the lively Westover Hills area, The Legend ensures you are never far from excitement and convenience. Residents have access to our resort-style pool, fitness center, and pet play area, making it a perfect spot for both relaxation and recreation. Discover your new home at The Legend and experience life in one of San Antonio's prime locations.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f6c12-f4f5-763a-896d-43ec1c536be3.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and island seating.",
        "public_id": "019f6c12-f4f5-763a-896d-43ec1c536be3",
        "storage_key": "property/5738013569056768/019f6c12-f4f5-763a-896d-43ec1c536be3.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "",
      "seo_description": "",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "custom",
      "page_item_url": "the-legend-2-bedroom-apartments-near-78227-31",
      "search_query": "2 bedroom apartments near 78227 san antonio",
      "category": "",
      "h1_title": "2 Bedroom Apartments Near 78227 San Antonio",
      "h2_subtitle": "Discover spacious 2 bedroom apartments near 78227 in San Antonio at The Legend, complete with top amenities and a vibrant lifestyle.",
      "page_copy": "Looking for 2 bedroom apartments near the 78227 area in San Antonio? The Legend offers stylish and spacious living options that cater to diverse needs. Situated in the Westover Hills community, these two-bedroom layouts provide comfortable living spaces fitted with modern amenities, such as air conditioning and fully-equipped kitchens.\n\nEnjoy community perks like our sparkling resort-style pool and comprehensive fitness center. The Legend ensures that lifestyle and convenience go hand in hand, providing residents with a welcoming atmosphere complete with a pet play area and lush grounds. Choose The Legend for your next home, where comfort and location harmonize perfectly.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f6c12-f4f5-763a-896d-43ec1c536be3.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and island seating.",
        "public_id": "019f6c12-f4f5-763a-896d-43ec1c536be3",
        "storage_key": "property/5738013569056768/019f6c12-f4f5-763a-896d-43ec1c536be3.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "",
      "seo_description": "",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "custom",
      "page_item_url": "the-legend-3-bedroom-apartments-bexar-county-tx-647",
      "search_query": "3 bedroom apartments bexar county tx",
      "category": "",
      "h1_title": "3 Bedroom Apartments Bexar County TX",
      "h2_subtitle": "Explore spacious 3 bedroom apartments in Bexar County, TX, at The Legend. Experience luxury living with superior amenities in San Antonio.",
      "page_copy": "For those seeking 3 bedroom apartments in Bexar County, TX, The Legend in San Antonio offers an unparalleled living experience. Our generously sized three-bedroom floor plans provide ample space and a suite of luxurious amenities designed for modern living. Each apartment is equipped with features like efficient air conditioning and premium appliances.\n\nLocated in the dynamic Westover Hills neighborhood, The Legend stands out with its resort-style pool, fitness center, and pet-friendly environment, creating a vibrant community atmosphere. Discover the perfect mix of convenience and comfort, ensuring a unique living experience in Bexar County. Let The Legend be your new home, where style meets substance in a prime location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f6c12-f4f5-763a-896d-43ec1c536be3.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and island seating.",
        "public_id": "019f6c12-f4f5-763a-896d-43ec1c536be3",
        "storage_key": "property/5738013569056768/019f6c12-f4f5-763a-896d-43ec1c536be3.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "",
      "seo_description": "",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "custom",
      "page_item_url": "the-legend-apartments-near-great-hearts-western-hills-755",
      "search_query": "apartments near great hearts western hills san antonio",
      "category": "",
      "h1_title": "Apartments Near Great Hearts Western Hills San Antonio",
      "h2_subtitle": "Find ideal apartments near Great Hearts Western Hills in San Antonio at The Legend. Enjoy excellent amenities and a prime location.",
      "page_copy": "Looking for apartments near Great Hearts Western Hills in San Antonio? The Legend offers the perfect blend of proximity and luxury. Located in the Westover Hills area, our community provides easy access to Great Hearts Western Hills, making it a convenient choice for families and professionals alike. Our apartment homes boast features like air conditioning and modern kitchens for a comfortable living experience.\n\nThe Legend is more than just a place to live; it's a vibrant community with excellent amenities. Enjoy our resort-style pool, state-of-the-art fitness center, and a welcoming pet play area. Our location ensures that you're well-connected while enjoying the tranquility of Westover Hills. Choose The Legend for a premium living experience close to everything you need.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f6c12-f4f5-763a-896d-43ec1c536be3.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and island seating.",
        "public_id": "019f6c12-f4f5-763a-896d-43ec1c536be3",
        "storage_key": "property/5738013569056768/019f6c12-f4f5-763a-896d-43ec1c536be3.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "",
      "seo_description": "",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "custom",
      "page_item_url": "the-legend-apartments-near-royal-point-academy-westover-hills-522",
      "search_query": "the legend apartments near royal point academy westover hills",
      "category": "",
      "h1_title": "The Legend Apartments Near Royal Point Academy",
      "h2_subtitle": "Explore The Legend apartments near Royal Point Academy, Westover Hills. Enjoy modern amenities and a convenient San Antonio location.",
      "page_copy": "Discover The Legend, the premier choice for those seeking apartments near Royal Point Academy in Westover Hills. Our San Antonio community offers a range of one, two, and three-bedroom floor plans, perfect for families, professionals, and everyone in between. Enjoy the convenience of living near Royal Point Academy while experiencing the best in apartment amenities.\n\nThe Legend boasts a resort-style pool, a well-equipped fitness center, and a pet-friendly atmosphere with a dedicated pet play area. Located in the vibrant Westover Hills neighborhood, The Legend combines the comforts of home with convenient access to local schools, shopping, and dining. Make The Legend your new home and experience the ideal blend of luxury and location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f6c12-f4f5-763a-896d-43ec1c536be3.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and island seating.",
        "public_id": "019f6c12-f4f5-763a-896d-43ec1c536be3",
        "storage_key": "property/5738013569056768/019f6c12-f4f5-763a-896d-43ec1c536be3.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "",
      "seo_description": "",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "custom",
      "page_item_url": "the-legend-apartments-close-to-gateway-christian-school-320",
      "search_query": "apartments close to gateway christian school bexar county",
      "category": "",
      "h1_title": "Apartments Close to Gateway Christian School",
      "h2_subtitle": "Discover apartments close to Gateway Christian School in Bexar County at The Legend. Unwind in a community that offers both convenience and luxury.",
      "page_copy": "If you're searching for apartments close to Gateway Christian School in Bexar County, look no further than The Legend. Located in the scenic Westover Hills, The Legend provides families and individuals with easy access to Gateway Christian School while offering a host of desirable amenities. Our spacious apartments, complete with air conditioning and modern kitchen appliances, ensure a comfortable living environment.\n\nAt The Legend, residents can enjoy the perks of a resort-style pool, a comprehensive fitness center, and a fun pet play area, making it a great place for everyone, including your furry friends. Discover the perfect mix of location, convenience, and luxury, all within a close-knit community. Make The Legend your choice for superior apartment living near Gateway Christian School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f6c12-f4f5-763a-896d-43ec1c536be3.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and island seating.",
        "public_id": "019f6c12-f4f5-763a-896d-43ec1c536be3",
        "storage_key": "property/5738013569056768/019f6c12-f4f5-763a-896d-43ec1c536be3.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "",
      "seo_description": "",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5738013569056768",
      "source": "custom",
      "page_item_url": "the-legend-san-antonio-apartments-near-john-jay-high-school-113",
      "search_query": "san antonio apartments near john jay high school",
      "category": "",
      "h1_title": "San Antonio Apartments Near John Jay High School",
      "h2_subtitle": "Explore San Antonio apartments near John Jay High School at The Legend. Enjoy the comfort and convenience of our vibrant community.",
      "page_copy": "The Legend offers the perfect solution for those seeking San Antonio apartments near John Jay High School. Situated in the lively Westover Hills neighborhood, The Legend provides the convenience of being close to John Jay High while also offering a peaceful retreat. Choose from our collection of one, two, and three-bedroom layouts, each designed to offer comfort and style.\n\nResidents of The Legend enjoy premium amenities such as a sparkling pool, a cutting-edge fitness center, and a pet-friendly environment complete with a dedicated play area for your furry companions. The central location, coupled with these fantastic features, makes The Legend an ideal choice for families and individuals alike who desire a harmonious balance between school proximity and luxurious living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5738013569056768/019f6c12-f4f5-763a-896d-43ec1c536be3.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and island seating.",
        "public_id": "019f6c12-f4f5-763a-896d-43ec1c536be3",
        "storage_key": "property/5738013569056768/019f6c12-f4f5-763a-896d-43ec1c536be3.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "",
      "seo_description": "",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2285"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2505043955"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a5d\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a5d\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4981188"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-W97SX24"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "3"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443916049"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "d1334bd0111f1888"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/5eve2e22vqo"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/cf7101a5-fed7-453d-8265-04971da192ce"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "361-316-4812"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImFlSzlva0V6N1FRSWlCMlloVTgzR2c9PSIsInZhbHVlIjoia2h3Y2lXMEZ1Y0xhMzNObThDVUwvZz09IiwibWFjIjoiM2I4YTkxYmYyZGEzMmI4YjgwMGVhYmFkMDBmODNjMzI2MWE1ZmRkOTllYWVmNWY3MzdlNDY1NGQ2YzJmZGQyYiJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2285",
  "custom_repli_id": "2505043955",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a5d\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a5d\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4981188",
  "custom_google_gtm_id": "GTM-W97SX24",
  "custom_rollout_phase": "3",
  "custom_ads_subscription": "full_stack",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443916049",
  "custom_knock_community_id": "d1334bd0111f1888",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/5eve2e22vqo",
  "custom_self_guided_tour_url": "https://selftournow.com/property/cf7101a5-fed7-453d-8265-04971da192ce",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "361-316-4812",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImFlSzlva0V6N1FRSWlCMlloVTgzR2c9PSIsInZhbHVlIjoia2h3Y2lXMEZ1Y0xhMzNObThDVUwvZz09IiwibWFjIjoiM2I4YTkxYmYyZGEzMmI4YjgwMGVhYmFkMDBmODNjMzI2MWE1ZmRkOTllYWVmNWY3MzdlNDY1NGQ2YzJmZGQyYiJ9",
  "custom_household_income_qualification_multiplier": "3"
};

export const generatedAt = '2026-10-09T16:35:23.338Z';
